// noinspection JSUnusedGlobalSymbols
//
// ------------------------------------------------------------------------------
//      Generated GraphQL schema for Join Program API
// ------------------------------------------------------------------------------
//      Stage        : Acceptance
//      Source       : https://api.acc.joinprogram.pwstaging.tech/graphql
//      Generated at : Thu Oct 22 07:28:58 UTC 2026
// ------------------------------------------------------------------------------

import { gql } from 'apollo-angular'
import { Injectable } from '@angular/core'
import * as Apollo from 'apollo-angular'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
    ID: { input: string; output: string }
    String: { input: string; output: string }
    Boolean: { input: boolean; output: boolean }
    Int: { input: number; output: number }
    Float: { input: number; output: number }
    /** The `Cent` scalar type represents price in cents */
    Cent: { input: number; output: number }
    Date: { input: string; output: string }
    DateTime: { input: string; output: string }
    /** An ISO compliant day-number value: 1 (monday) through 7 (sunday) */
    IsoDayNumber: { input: 1 | 2 | 3 | 4 | 5 | 6 | 7; output: 1 | 2 | 3 | 4 | 5 | 6 | 7 }
    /** An ISO compliant week-number (1 through 53) */
    IsoWeekNumber: { input: number; output: number }
    /** An ISO compliant week-year value. This is not the same thing as the gregorian year! */
    IsoWeekYear: { input: number; output: number }
    /** Represents a Pubsub message ID */
    MessageID: { input: string; output: string }
    /** Represents a Semver version number such as "1.2.3" */
    Semver: { input: string; output: string }
    /** Represents a Semver version range such as " >= 1.2.3 || 3.x" */
    SemverRange: { input: string; output: string }
    /** Any string that represents a certain time of day, e.g. "13:30" or "15:45:20". */
    TimeString: { input: string; output: string }
    /** A string value that will have one or multiple translations */
    TranslatableString: { input: string; output: string }
    /** Can be used as an argument to upload files using https://github.com/jaydenseric/graphql-multipart-request-spec */
    Upload: { input: File; output: File }
}

/**
 * This enum specifies all types of access users might conceptually request.
 * One might want to view a list of items, edit a specific one or delete
 * all of a list of items. This enum, when combined with the {@link CrudAction}
 * enum, encodes all of these possible requests the system must be able to respond to.
 */
export enum AccessType {
    /**
   * The "EXACT" case indicates the assertion that a specific model or list of models can be operated on.
   * This is useful to check whether an authorizable can be presented with capabilities to perform
   * requested actions on this set of models.
   */
    Exact = 'EXACT',
    /**
   * The "SOME" case indicates the assertion that _some_ instances of a model
   * can be operated on, without necessarily specifying which models can come
   * into scope. This is useful for two situations:
   *
   * 1. to check whether an authorizable entity can be presented with indexes
   * of models (e.g. overview pages). In that case we don't need to know in
   * advance which instances will be presented, just that as per set permissions,
   * _some_ might show up.
   *
   * 2. When creating models. When a request for a model creation is received,
   * the models to be created do not yet exist. Therefore, we cannot match these
   * models against keys as we would with the EXACT access-type.
   * The initial authorization can only check that _some_ models of a certain
   * type may be created by the user. After creation, it _is_ possible to do
   * another authorization check against the key(s) of the just created model(s).
   */
    Some = 'SOME',
}

export interface Addition {
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
    readonly price: Scalars['Cent']['output']
    readonly translations: ReadonlyArray<AdditionTranslation>
}

export interface AdditionBelongsTo {
    readonly connect: Scalars['ID']['input']
}

export interface AdditionSalesEntry {
    readonly addition: Addition
    readonly amountClaimed: Scalars['Int']['output']
    readonly amountIssued: Scalars['Int']['output']
    readonly amountReserved: Scalars['Int']['output']
}

export interface AdditionTranslation {
    readonly locale: Scalars['String']['output']
    readonly name: Scalars['String']['output']
}

export interface AdditionTranslationInput {
    readonly locale: Scalars['String']['input']
    readonly name: Scalars['String']['input']
}

/** A single ad-hoc serving recorded when kitchen/backoffice staff issues available stock without an order. */
export interface AdhocServing {
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    readonly quantity: Scalars['Int']['output']
    readonly user?: Maybe<User>
}

export interface Allergen {
    readonly children: ReadonlyArray<Allergen>
    readonly displayName: Scalars['String']['output']
    readonly icon?: Maybe<Scalars['String']['output']>
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
    readonly parent?: Maybe<Allergen>
    readonly translations: ReadonlyArray<AllergenTranslation>
}


export interface AllergenIconArgs {
    variant?: InputMaybe<AllergenIconVariant>
}

export interface AllergenGroupDeclaration {
    readonly group: Allergen
    readonly presence: AllergenPresence
    readonly specifics: ReadonlyArray<Allergen>
}

/** Allowed resizes for the `variant` argument on the query `icon`. */
export enum AllergenIconVariant {
    Original = 'ORIGINAL',
}

export enum AllergenPresence {
    Contains = 'CONTAINS',
    MayContain = 'MAY_CONTAIN',
}

export interface AllergenTranslation {
    readonly displayName: Scalars['String']['output']
    readonly locale: Scalars['String']['output']
}

export interface AllergenTranslationInput {
    readonly displayName: Scalars['String']['input']
    readonly locale: Scalars['String']['input']
}

export interface AllergensBelongsTo {
    readonly connect: Scalars['ID']['input']
}

export interface AllergensFilterInput {
    readonly query?: InputMaybe<Scalars['String']['input']>
}

export interface AllergensInput {
    readonly filters?: InputMaybe<LocationsFilterInput>
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface AllergensPaginator {
    readonly data: ReadonlyArray<Allergen>
    readonly paginatorInfo: PaginatorInfo
}

export interface AmbianceImages {
    readonly original: Scalars['String']['output']
    readonly rectangle_615: Scalars['String']['output']
}

export interface Amount {
    readonly currency: Scalars['String']['output']
    readonly value: Scalars['String']['output']
}

export interface Answer {
    readonly answer: Scalars['String']['output']
    readonly answeredDate: Scalars['Date']['output']
    readonly id: Scalars['ID']['output']
    readonly note?: Maybe<Scalars['String']['output']>
    readonly question: Question
    readonly user?: Maybe<User>
}

export enum AnswerEnum {
    AgreementLevel_1 = 'AGREEMENT_LEVEL_1',
    AgreementLevel_2 = 'AGREEMENT_LEVEL_2',
    AgreementLevel_3 = 'AGREEMENT_LEVEL_3',
    AgreementLevel_4 = 'AGREEMENT_LEVEL_4',
    AgreementLevel_5 = 'AGREEMENT_LEVEL_5',
    Smiley_1 = 'SMILEY_1',
    Smiley_2 = 'SMILEY_2',
    Smiley_3 = 'SMILEY_3',
    Smiley_4 = 'SMILEY_4',
    Star_1 = 'STAR_1',
    Star_2 = 'STAR_2',
    Star_3 = 'STAR_3',
    Star_4 = 'STAR_4',
    Star_5 = 'STAR_5',
}

export interface AnswersInput {
    readonly questionId: Scalars['ID']['input']
}

export interface ApiVersion {
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    readonly updatedAt: Scalars['DateTime']['output']
    readonly version: Scalars['String']['output']
}

export interface AppCompatibilityStatus {
    /** True if the API accepts the given app version. */
    readonly apiSupportsApp: Scalars['Boolean']['output']
    /** The current Semver version of the API. */
    readonly apiVersion: Scalars['Semver']['output']
    /** True if the app accepts the current API version. */
    readonly appSupportsApi: Scalars['Boolean']['output']
    /** The given Semver version of the app; is in the response for reference and debugging. */
    readonly appVersion: Scalars['Semver']['output']
    /** True if both the app and API are happy with each other's current version. */
    readonly compatible: Scalars['Boolean']['output']
}

export interface AssignProductCategoriesToRestaurantInput {
    readonly productCategoryIds: ReadonlyArray<Scalars['ID']['input']>
    readonly restaurantId: Scalars['ID']['input']
}

export interface AssignProductCategoryPricesToClientInput {
    readonly clientId: Scalars['ID']['input']
    readonly productCategoryPrices: ReadonlyArray<ProductCategoryPriceInput>
}

export interface AuthPayload {
    readonly access_token?: Maybe<Scalars['String']['output']>
    readonly expires_in?: Maybe<Scalars['Int']['output']>
    readonly refresh_token?: Maybe<Scalars['String']['output']>
    readonly token_type?: Maybe<Scalars['String']['output']>
    readonly user?: Maybe<User>
}

export interface Cart {
    readonly items: ReadonlyArray<CartItem>
}

export interface CartItem {
    readonly name?: Maybe<Scalars['String']['output']>
    readonly ourPrice?: Maybe<Scalars['Cent']['output']>
    readonly price: Scalars['Float']['output']
    readonly productId: Scalars['ID']['output']
    readonly quantity: Scalars['Int']['output']
}

export interface CartPreview {
    readonly addressId?: Maybe<Scalars['ID']['output']>
    readonly brandId: Scalars['ID']['output']
    readonly cart: Cart
    readonly channelId: Scalars['ID']['output']
    readonly comment?: Maybe<Scalars['String']['output']>
    readonly consumptionMode: Scalars['String']['output']
    readonly currency: Scalars['String']['output']
    readonly customerId?: Maybe<Scalars['ID']['output']>
    readonly expectedAt?: Maybe<Scalars['DateTime']['output']>
    readonly expectedAtEnd?: Maybe<Scalars['DateTime']['output']>
    readonly menuId: Scalars['ID']['output']
    readonly recap: CartRecap
    readonly restaurantId: Scalars['ID']['output']
    readonly tableName?: Maybe<Scalars['String']['output']>
}

export interface CartRecap {
    readonly currency?: Maybe<Scalars['String']['output']>
    readonly ourTotal?: Maybe<Scalars['Cent']['output']>
    readonly subtotal?: Maybe<Scalars['Float']['output']>
    readonly tax?: Maybe<Scalars['Float']['output']>
    readonly total?: Maybe<Scalars['Float']['output']>
    readonly totalInclTaxWithDiscount?: Maybe<Scalars['Int']['output']>
}

export interface Category {
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
}

export interface ChangeOfficeDaysInput {
    readonly days: ReadonlyArray<InputMaybe<WeekDayEnum>>
}

export interface Client {
    readonly deactivatedAt?: Maybe<Scalars['Date']['output']>
    readonly domains: ReadonlyArray<Domain>
    readonly emailQuestionsTo: Scalars['String']['output']
    readonly employeeCount: Scalars['Int']['output']
    readonly hasIdentityProvider: Scalars['Boolean']['output']
    readonly id: Scalars['ID']['output']
    readonly isDemo: Scalars['Boolean']['output']
    readonly logo: Scalars['String']['output']
    readonly name: Scalars['String']['output']
    readonly onboardingSteps: ReadonlyArray<OnboardingStepsEnum>
    readonly ratingContexts: ReadonlyArray<RatingContextsEnum>
    readonly registrationShortcode: Scalars['String']['output']
    readonly themes: ClientThemes
}

/** A paginated list of Client items. */
export interface ClientPaginator {
    /** A list of Client items. */
    readonly data: ReadonlyArray<Client>
    /** Pagination information about the list of items. */
    readonly paginatorInfo: PaginatorInfo
}

export enum ClientResolutionStrategyEnum {
    Domain = 'DOMAIN',
    Email = 'EMAIL',
    Shortcode = 'SHORTCODE',
}

/**
 * Indicates the association between a Client and a Restaurant, i.e. that the Restaurant is made
 * available to the client. It also specifies the order-strategy that the restaurant maintains for
 * this particular client, as well as an optional note about the order-strategy that can be shown to
 * end users.
 */
export interface ClientRestaurantAssociation {
    readonly client: Client
    readonly orderStrategy: OrderStrategyEnum
    readonly orderStrategyNote?: Maybe<Scalars['String']['output']>
    readonly restaurant: Restaurant
}

export interface ClientRestaurantAssociationInput {
    readonly orderStrategy: OrderStrategyEnum
    readonly orderStrategyNote?: InputMaybe<Scalars['String']['input']>
    readonly restaurantId: Scalars['ID']['input']
}

export interface ClientTheme {
    readonly colorDark: Scalars['String']['output']
    readonly colorDarkContrast: Scalars['String']['output']
    /** @deprecated This field will be removed in the next major release */
    readonly colorError: Scalars['String']['output']
    /** @deprecated This field will be removed in the next major release */
    readonly colorErrorContrast: Scalars['String']['output']
    readonly colorPrimary: Scalars['String']['output']
    readonly colorPrimaryContrast: Scalars['String']['output']
    readonly colorSecondary: Scalars['String']['output']
    readonly colorSecondaryContrast: Scalars['String']['output']
    /** @deprecated This field will be removed in the next major release */
    readonly colorSuccess: Scalars['String']['output']
    /** @deprecated This field will be removed in the next major release */
    readonly colorSuccessContrast: Scalars['String']['output']
    readonly colorTertiary: Scalars['String']['output']
    readonly colorTertiaryContrast: Scalars['String']['output']
    /** @deprecated Use colorDark instead */
    readonly colorTextDark: Scalars['String']['output']
    /** @deprecated Use colorDarkContrast instead */
    readonly colorTextLight: Scalars['String']['output']
    /** @deprecated This field will be removed in the next major release */
    readonly colorWarning: Scalars['String']['output']
    /** @deprecated This field will be removed in the next major release */
    readonly colorWarningContrast: Scalars['String']['output']
    /** @deprecated This field will be removed in the next major release */
    readonly contextualColors: ReadonlyArray<ContextualColor>
}

export interface ClientThemes {
    readonly app: ClientTheme
    readonly web: ClientTheme
}

/** Lists all the associations and their auxiliary pivot data of Restaurants with a particular Client. */
export interface ClientWithRestaurantAssociations {
    readonly associations: ReadonlyArray<ClientRestaurantAssociation>
    readonly client: Client
}

export interface ClientsFilterInput {
    readonly isDemo?: InputMaybe<Scalars['Boolean']['input']>
    readonly query?: InputMaybe<Scalars['String']['input']>
}

export interface ClientsInput {
    readonly filters?: InputMaybe<ClientsFilterInput>
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface ClosedDate {
    readonly clientId?: Maybe<Scalars['ID']['output']>
    readonly content: Scalars['String']['output']
    readonly endDate: Scalars['Date']['output']
    readonly icon: ClosedDateIconEnum
    readonly id: Scalars['ID']['output']
    readonly startingDate: Scalars['Date']['output']
    readonly title: Scalars['String']['output']
}

export enum ClosedDateIconEnum {
    ClosedChristmas = 'CLOSED_CHRISTMAS',
    ClosedEaster = 'CLOSED_EASTER',
    ClosedGear = 'CLOSED_GEAR',
    ClosedIceCream = 'CLOSED_ICE_CREAM',
    ClosedKingsday = 'CLOSED_KINGSDAY',
    ClosedSocks = 'CLOSED_SOCKS',
    ClosedSun = 'CLOSED_SUN',
    ClosedToday = 'CLOSED_TODAY',
    ClosedTree = 'CLOSED_TREE',
    ClosedWrench = 'CLOSED_WRENCH',
}

export interface ContentMedia {
    readonly fileName: Scalars['String']['output']
    readonly id: Scalars['ID']['output']
    readonly media: Scalars['String']['output']
    readonly newsItems?: Maybe<ReadonlyArray<NewsItem>>
}


export interface ContentMediaMediaArgs {
    variant?: InputMaybe<ContentMediaMediaVariant>
}

/** Allowed resizes for the `variant` argument on the query `media`. */
export enum ContentMediaMediaVariant {
    Original = 'ORIGINAL',
    Rectangle_1200 = 'RECTANGLE_1200',
}

export interface ContentMediaPaginator {
    readonly data: ReadonlyArray<ContentMedia>
    readonly paginatorInfo: PaginatorInfo
}

/**
 * Union type for all mediable content types.
 * Currently only NewsItem.
 */
export type ContentMediable = NewsItem

export interface ContentMediasInput {
    readonly pagination: PaginationInput
}

export interface ContextualColor {
    readonly name: Scalars['String']['output']
    readonly value: Scalars['String']['output']
}

export interface ContextualColorInput {
    readonly name: Scalars['String']['input']
    readonly value: Scalars['String']['input']
}

export interface CreateAdditionInput {
    readonly price: Scalars['Cent']['input']
    readonly translations: ReadonlyArray<AdditionTranslationInput>
}

export interface CreateAnswerInput {
    /**
   * - For Multiple choice type questions: `"1" | "2" | "3" | "4" | "5"`
   * - For Star type questions: `"1" | "2" | "3" | "4" | "5"`
   * - For Smiley type questions: `"1" | "2" | "3" | "4"`
   * - For Open-ended type questions: any string
   */
    readonly answer: Scalars['String']['input']
    readonly note?: InputMaybe<Scalars['String']['input']>
    readonly questionId: Scalars['ID']['input']
}

export interface CreateCategoryInput {
    readonly name: Scalars['String']['input']
}

export interface CreateClientInput {
    readonly deactivatedAt?: InputMaybe<Scalars['Date']['input']>
    readonly emailQuestionsTo: Scalars['String']['input']
    readonly isDemo: Scalars['Boolean']['input']
    readonly logo?: InputMaybe<DeletableFileInput>
    readonly name: Scalars['String']['input']
    readonly onboardingSteps: ReadonlyArray<OnboardingStepsEnum>
    readonly ratingContexts: ReadonlyArray<RatingContextsEnum>
}

export interface CreateClosedDateInput {
    readonly clientId?: InputMaybe<Scalars['ID']['input']>
    readonly content: Scalars['String']['input']
    readonly endDate: Scalars['Date']['input']
    readonly icon: ClosedDateIconEnum
    readonly startingDate: Scalars['Date']['input']
    readonly title: Scalars['String']['input']
}

export interface CreateDailyGuestEstimationInput {
    readonly estimation: Scalars['Int']['input']
    readonly isoWeekNumber: Scalars['Int']['input']
    readonly isoWeekYear: Scalars['Int']['input']
    readonly isoWeekday: WeekDayEnum
    readonly restaurantId: Scalars['ID']['input']
}

export interface CreateDishRatingInput {
    readonly consumptionDate: Scalars['Date']['input']
    readonly note?: InputMaybe<Scalars['String']['input']>
    readonly productId: Scalars['ID']['input']
    readonly rating: Scalars['Int']['input']
    readonly restaurantId: Scalars['ID']['input']
    readonly type: DishRatingTypeEnum
}

export interface CreateDismissRatingInput {
    readonly consumptionDate: Scalars['Date']['input']
    readonly productId: Scalars['ID']['input']
}

export interface CreateDomainInput {
    readonly clientId: Scalars['ID']['input']
    readonly domains: ReadonlyArray<DomainInput>
}

export interface CreateInnovorderMenuTagInput {
    readonly color: Scalars['String']['input']
    readonly isEnabled?: InputMaybe<Scalars['Boolean']['input']>
    readonly name: Scalars['String']['input']
}

export interface CreateInternalVoucherInput {
    readonly activeFrom: Scalars['DateTime']['input']
    readonly activeUntil: Scalars['DateTime']['input']
    readonly initialAmount: Scalars['Cent']['input']
    readonly userId: Scalars['ID']['input']
}

export interface CreateLocationInput {
    readonly cityName: Scalars['String']['input']
    readonly costCenter?: InputMaybe<Scalars['String']['input']>
    readonly name: Scalars['String']['input']
    readonly postalCode: Scalars['String']['input']
    readonly streetName: Scalars['String']['input']
    readonly streetNumber: Scalars['String']['input']
}

export interface CreateLoginSessionInput {
    readonly codeChallenge: Scalars['String']['input']
    readonly email?: InputMaybe<Scalars['String']['input']>
    readonly fallbackRedirectUri: Scalars['String']['input']
    readonly redirectUri: Scalars['String']['input']
    readonly shortcode?: InputMaybe<Scalars['String']['input']>
}

export interface CreateLoginSessionResponse {
    readonly clientResolutionStrategy: ClientResolutionStrategyEnum
    readonly isFallbackRedirectUri: Scalars['Boolean']['output']
    readonly redirectUri: Scalars['String']['output']
}

export interface CreateNarrowcastingTabletInput {
    readonly name?: InputMaybe<Scalars['String']['input']>
}

export interface CreateNarrowcastingTabletScheduleInput {
    readonly endDate: Scalars['Date']['input']
    readonly productIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly startDate: Scalars['Date']['input']
    readonly tabletId: Scalars['ID']['input']
    readonly template: NarrowcastingDisplayTemplateEnum
}

export interface CreateNutrientForProductVersionInput {
    readonly nutrientTypeId: Scalars['ID']['input']
    readonly perHundredGram: Scalars['Float']['input']
}

export interface CreatePollInput {
    readonly clients: ReadonlyArray<QuestionClientInput>
    readonly endDate: Scalars['Date']['input']
    readonly startDate: Scalars['Date']['input']
    readonly translations: ReadonlyArray<QuestionTranslationInput>
    readonly type: QuestionTypeEnum
}

export interface CreateProductCategoryInput {
    readonly name: Scalars['String']['input']
    readonly publicCategory: Scalars['ID']['input']
}

export interface CreateProductInput {
    readonly additions?: InputMaybe<ReadonlyArray<CreateAdditionInput>>
    readonly allergenDeclarations?: InputMaybe<ReadonlyArray<ProductAllergenInput>>
    readonly category: Scalars['ID']['input']
    readonly dietaryClass?: InputMaybe<DietaryClassEnum>
    readonly image?: InputMaybe<DeletableFileInput>
    readonly marginPercentage: Scalars['Int']['input']
    readonly nutrients?: InputMaybe<ReadonlyArray<CreateNutrientForProductVersionInput>>
    readonly price: Scalars['Cent']['input']
    readonly tags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly translations: ReadonlyArray<ProductTranslationInput>
    readonly type: ProductTypeEnum
    readonly vatTariffPercentage?: InputMaybe<Scalars['Int']['input']>
    readonly versionTranslations: ReadonlyArray<ProductVersionTranslationInput>
}

/**
 * The `CreatePublicCategoryInput` is auto generated by @translatable directive.
 * It only contains a translatable field `name` and therefore it couldn't auto generated.
 * Therefore it is manually defined here.
 */
export interface CreatePublicCategoryInput {
    readonly translations: ReadonlyArray<PublicCategoryTranslationInput>
}

export interface CreateRestaurantInput {
    readonly allowPickUpAtTheOffice: Scalars['Boolean']['input']
    readonly ambianceImage?: InputMaybe<DeletableFileInput>
    readonly dishBackgroundImage?: InputMaybe<DeletableFileInput>
    readonly locationId?: InputMaybe<Scalars['ID']['input']>
    readonly name: Scalars['String']['input']
    readonly orderDeadlineMarginMinutes: Scalars['Int']['input']
    readonly purchaseEnabled?: InputMaybe<Scalars['Boolean']['input']>
    readonly qrCodePickup: Scalars['Boolean']['input']
    readonly serviceReferenceId?: InputMaybe<Scalars['String']['input']>
    readonly translations: ReadonlyArray<RestaurantTranslationInput>
    readonly type: RestaurantTypeEnum
}

export interface CreateUserInput {
    readonly clientId: Scalars['ID']['input']
    readonly email: Scalars['String']['input']
    readonly firstName: Scalars['String']['input']
    readonly lastName: Scalars['String']['input']
    readonly locationId?: InputMaybe<Scalars['ID']['input']>
    readonly preferredLanguage?: InputMaybe<Scalars['String']['input']>
    readonly restaurantId?: InputMaybe<Scalars['ID']['input']>
    readonly roles?: InputMaybe<ReadonlyArray<RoleInput>>
    readonly userType?: InputMaybe<UserTypeEnum>
}

/**
 * This enum is used to determine where {@link \App\Models\MenuEntry menu-entries} and
 * {@link \App\Models\MenuEntryOccurrence occurrences} originate from.
 *
 * - Some of them are created through the backoffice menu creator UI - denoted with BACKOFFICE_MENU_CREATOR
 * - Some are created by patching {@link \App\Models\TemplateMenu templates} onto the menu - denoted with WRITTEN_FROM_TEMPLATE.
 *
 * This is useful to filter items by within backoffice queries for the menu creator UI, so that after writing a template,
 * this UI does not suddenly show all the written items alongside items that were originally created manually.
 */
export enum CreationSourceEnum {
    BackofficeMenuCreator = 'BACKOFFICE_MENU_CREATOR',
    WrittenFromTemplate = 'WRITTEN_FROM_TEMPLATE',
}

export enum CrudAction {
    Create = 'CREATE',
    Delete = 'DELETE',
    Read = 'READ',
    Update = 'UPDATE',
}

export enum CurrencyEnum {
    Euro = 'EURO',
    GreatBritainPound = 'GREAT_BRITAIN_POUND',
    UnitedStatesDollar = 'UNITED_STATES_DOLLAR',
}

export interface DailyGuestEstimation {
    readonly createdAt: Scalars['DateTime']['output']
    readonly estimation: Scalars['Int']['output']
    readonly id: Scalars['ID']['output']
    readonly isoWeekNotation: Scalars['String']['output']
    readonly isoWeekNumber: Scalars['IsoWeekNumber']['output']
    readonly isoWeekYear: Scalars['IsoWeekYear']['output']
    readonly isoWeekday: WeekDayEnum
    readonly restaurant: Restaurant
    readonly updatedAt: Scalars['DateTime']['output']
}

export interface DailyGuestEstimationFilterInput {
    readonly isoWeekNumber: Scalars['Int']['input']
    readonly isoWeekYear: Scalars['Int']['input']
    readonly restaurantId: Scalars['ID']['input']
}

/** The response type of the `dailyMenu` GraphQL query. */
export interface DailyMenu {
    readonly date: Scalars['Date']['output']
    readonly isClosed: Scalars['Boolean']['output']
    readonly restaurants: ReadonlyArray<DailyMenuRestaurant>
}

export interface DailyMenuFilters {
    readonly dietaryClasses?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>
    readonly locations?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    /** DEPRECATED. Use publicCategories instead. */
    readonly productCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly productTypes?: InputMaybe<ReadonlyArray<ProductTypeEnum>>
    readonly publicCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

/** A single item served at the containing restaurant on the queried date. */
export interface DailyMenuItem {
    readonly additions: ReadonlyArray<Addition>
    readonly allergenGroups: ReadonlyArray<AllergenGroupDeclaration>
    /** @deprecated Use allergenGroups. */
    readonly allergens: ReadonlyArray<Allergen>
    /** @deprecated Use publicCategory instead. */
    readonly category: ProductCategory
    readonly context: DailyMenuItemContext
    readonly description?: Maybe<Scalars['String']['output']>
    readonly dietaryClass?: Maybe<Scalars['String']['output']>
    readonly images?: Maybe<DailyMenuItemImages>
    readonly name: Scalars['String']['output']
    readonly nutrients: ReadonlyArray<Nutrient>
    readonly price: Scalars['Cent']['output']
    readonly publicCategory: PublicCategory
    readonly sources: DailyMenuItemSourceIDs
    readonly stock: StockNumbers
    readonly tagline?: Maybe<Scalars['String']['output']>
    readonly tags: ReadonlyArray<Tag>
    readonly type: ProductTypeEnum
}

/**
 * A context object that tells where in the DailyMenu type a DailyMenuItem was provided.
 * This can be useful when an item is taken out of context in a front-end application but
 * the determining properties of its context are ad-hoc required for any reason.
 */
export interface DailyMenuItemContext {
    readonly date: Scalars['Date']['output']
    readonly restaurantID: Scalars['ID']['output']
}

/**
 * The set of images in different sizes for a DailyMenuItem.
 * Note: ORIGINAL may be very large and expensive to render.
 */
export interface DailyMenuItemImages {
    readonly original: Scalars['String']['output']
    readonly square150: Scalars['String']['output']
    readonly square300: Scalars['String']['output']
    readonly square600: Scalars['String']['output']
}

/**
 * The unique IDs of most sources used for generating a DailyMenuItem object.
 * These IDs may be necessary as references when placing orders.
 */
export interface DailyMenuItemSourceIDs {
    readonly menu: Scalars['ID']['output']
    readonly menuEntry: Scalars['ID']['output']
    readonly menuEntryOccurrence: Scalars['ID']['output']
    readonly product: Scalars['ID']['output']
    readonly productVersion: Scalars['ID']['output']
}

export interface DailyMenuRestaurant {
    readonly items: ReadonlyArray<DailyMenuItem>
    readonly restaurant: Restaurant
}

export interface DailyOpeningHours {
    readonly closingTime: Scalars['TimeString']['output']
    readonly openingTime: Scalars['TimeString']['output']
    readonly weekday: WeekDayEnum
}

export interface DateNotations {
    readonly isoDate: Scalars['Date']['output']
    readonly isoWeekDate: Scalars['String']['output']
}

export interface DeletableFileInput {
    readonly delete?: InputMaybe<Scalars['Boolean']['input']>
    readonly file?: InputMaybe<Scalars['Upload']['input']>
}

export interface DeliveryAddressInput {
    readonly cityName: Scalars['String']['input']
    readonly postalCode: Scalars['String']['input']
    readonly streetName: Scalars['String']['input']
    readonly streetNumber: Scalars['String']['input']
}

export interface DietaryClass {
    readonly key: Scalars['String']['output']
    readonly value: Scalars['String']['output']
}

export enum DietaryClassEnum {
    Beef = 'BEEF',
    Fish = 'FISH',
    Lamb = 'LAMB',
    MixedMeatsOther = 'MIXED_MEATS_OTHER',
    PlantBased = 'PLANT_BASED',
    Pork = 'PORK',
    Poultry = 'POULTRY',
    Vegetarian = 'VEGETARIAN',
}

export interface DishBackgroundImages {
    readonly ORIGINAL: Scalars['String']['output']
    readonly SQUARE_150: Scalars['String']['output']
    readonly SQUARE_300: Scalars['String']['output']
    readonly SQUARE_600: Scalars['String']['output']
}

export interface DishRating {
    readonly consumptionDate: Scalars['Date']['output']
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    readonly note?: Maybe<Scalars['String']['output']>
    readonly product: Product
    readonly rating: Scalars['Int']['output']
    readonly restaurant: Restaurant
    readonly type: DishRatingTypeEnum
    readonly user: User
}

/** A single average rating with associated data for the product by contained ID. */
export interface DishRatingAverage {
    readonly averageRating: Scalars['Float']['output']
    readonly clientNames: ReadonlyArray<Scalars['String']['output']>
    readonly dietaryClass?: Maybe<DietaryClassEnum>
    readonly productCategoryID: Scalars['ID']['output']
    readonly productCategoryName: Scalars['String']['output']
    readonly productID: Scalars['ID']['output']
    readonly productName: Scalars['String']['output']
    readonly totalRatings: Scalars['Int']['output']
}

export interface DishRatingAveragesInput {
    readonly clientIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly endDate: Scalars['Date']['input']
    readonly startDate: Scalars['Date']['input']
}

export interface DishRatingAveragesPaginator {
    readonly data: ReadonlyArray<DishRatingAverage>
    readonly paginatorInfo: PaginatorInfo
}

export enum DishRatingTypeEnum {
    DishDetail = 'DISH_DETAIL',
    OrderedDish = 'ORDERED_DISH',
}

export interface DishRatingsExportInput {
    readonly clientIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly endDate: Scalars['Date']['input']
    readonly productId: Scalars['ID']['input']
    readonly restaurantIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly startDate: Scalars['Date']['input']
}

export interface DishRatingsPaginator {
    readonly data: ReadonlyArray<DishRating>
    readonly paginatorInfo: PaginatorInfo
}

export interface DishRatingsStatisticsInput {
    readonly categories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly dietaryClasses?: InputMaybe<ReadonlyArray<DietaryClassEnum>>
    readonly endDate?: InputMaybe<Scalars['Date']['input']>
    readonly searchQuery?: InputMaybe<Scalars['String']['input']>
    readonly startDate?: InputMaybe<Scalars['Date']['input']>
}

export interface DismissedRating {
    readonly consumptionDate: Scalars['Date']['output']
    readonly id: Scalars['ID']['output']
    readonly product: Product
    readonly user: User
}

export interface Domain {
    readonly client: Client
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
}

export interface DomainInput {
    readonly name: Scalars['String']['input']
}

export interface ExternalCategory {
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
    readonly productCategory?: Maybe<ProductCategory>
    readonly source: ExternalCategorySourceEnum
    readonly updatedAt: Scalars['DateTime']['output']
}

export enum ExternalCategorySourceEnum {
    Apicbase = 'APICBASE',
}

export enum FeedbackSortableColumnEnum {
    AverageRating = 'AVERAGE_RATING',
    TotalRatings = 'TOTAL_RATINGS',
}

/**
 * FileExport type
 * The url field will contain the url to the file download
 */
export interface FileExport {
    readonly createdAt: Scalars['DateTime']['output']
    readonly downloadId: Scalars['String']['output']
    readonly fileName?: Maybe<Scalars['String']['output']>
    readonly fileSize?: Maybe<Scalars['Int']['output']>
    readonly id: Scalars['ID']['output']
    readonly status: FileExportStatusEnum
    readonly type: FileExportTypeEnum
    readonly updatedAt: Scalars['DateTime']['output']
    readonly url?: Maybe<Scalars['String']['output']>
    readonly user?: Maybe<User>
}

/** Typed response for FileExportInput */
export interface FileExportInputResponse {
    readonly fileId?: Maybe<Scalars['ID']['output']>
    readonly status: FileExportStatusEnum
    readonly type: FileExportTypeEnum
}

export enum FileExportStatusEnum {
    Downloaded = 'DOWNLOADED',
    Failed = 'FAILED',
    Finished = 'FINISHED',
    Pending = 'PENDING',
    Processing = 'PROCESSING',
}

export enum FileExportTypeEnum {
    DishRatings = 'DISH_RATINGS',
    DishRatingAverages = 'DISH_RATING_AVERAGES',
    Finance = 'FINANCE',
    Orders = 'ORDERS',
    OrderSheets = 'ORDER_SHEETS',
    Poll = 'POLL',
    Vouchers = 'VOUCHERS',
}

export interface FileExportsPaginator {
    readonly data: ReadonlyArray<FileExport>
    readonly paginatorInfo: PaginatorInfo
}

export interface FinanceDataFilterInput {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly endDate: Scalars['Date']['input']
    readonly restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly startDate: Scalars['Date']['input']
}

export interface FinanceDataForPayment {
    readonly financeData: FinanceDataPaymentSubjects
    readonly paymentMethod: Scalars['String']['output']
}

export interface FinanceDataForProductCategory {
    readonly financeData: FinanceDataSubjects
    readonly productCategory: Scalars['String']['output']
}

export interface FinanceDataForProductType {
    readonly financeData: FinanceDataSubjects
    readonly productType: ProductTypeEnum
}

export interface FinanceDataForSummary {
    readonly financeData: FinanceDataSummarySubjects
    readonly type: Scalars['String']['output']
}

export interface FinanceDataPaymentSubjects {
    readonly average: Scalars['Float']['output']
    readonly created: Scalars['Int']['output']
    readonly feesAverage: Scalars['Float']['output']
    readonly feesTotal: Scalars['Float']['output']
    readonly successful: Scalars['Int']['output']
    readonly total: Scalars['Float']['output']
}

export interface FinanceDataSubjects {
    readonly averageSumWithVat: Scalars['Float']['output']
    readonly averageSumWithoutVat: Scalars['Float']['output']
    readonly sumWithVat: Scalars['Float']['output']
    readonly sumWithoutVat: Scalars['Float']['output']
    readonly totalNumberOfTickets: Scalars['Int']['output']
}

export interface FinanceDataSummarySubjects {
    readonly additionCostPrice: Scalars['Float']['output']
    readonly averageCostPrice: Scalars['Float']['output']
    readonly averageOrderMargin: Scalars['Float']['output']
    readonly averageWithVat: Scalars['Float']['output']
    readonly averageWithoutVat: Scalars['Float']['output']
    readonly costPrice: Scalars['Float']['output']
    readonly orderCount: Scalars['Int']['output']
    readonly perVAT: ReadonlyArray<FinanceDataSummaryVat>
    readonly salesMargin: Scalars['Float']['output']
    readonly withVAT: Scalars['Float']['output']
    readonly withoutVAT: Scalars['Float']['output']
}

export interface FinanceDataSummaryVat {
    readonly totalRevenue: Scalars['Float']['output']
    readonly vatTariff: Scalars['Float']['output']
}

export interface FinancialOrdersExportInput {
    readonly clientIds: ReadonlyArray<Scalars['ID']['input']>
    readonly endDate: Scalars['Date']['input']
    readonly restaurantIds: ReadonlyArray<Scalars['ID']['input']>
    readonly startDate: Scalars['Date']['input']
}

export interface FinishLoginSessionInput {
    readonly acceptsPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>
    readonly acceptsTerms?: InputMaybe<Scalars['Boolean']['input']>
    readonly codeVerifier: Scalars['String']['input']
    readonly exchangeToken: Scalars['String']['input']
}

export interface ForgotPasswordInput {
    readonly callbackUrl: ResetPasswordUrlInput
    readonly email: Scalars['String']['input']
}

export interface ForgotPasswordResponse {
    readonly message?: Maybe<Scalars['String']['output']>
    readonly status: Scalars['String']['output']
}

export enum InnovorderChannelEnum {
    ChannelKiosk = 'CHANNEL_KIOSK',
    ChannelPos = 'CHANNEL_POS',
    ChannelWeb = 'CHANNEL_WEB',
}

export interface InnovorderClientLink {
    readonly brandId: Scalars['ID']['output']
    readonly client: Client
    readonly clientId: Scalars['ID']['output']
    readonly id: Scalars['ID']['output']
}

export interface InnovorderForgottenPasswordInput {
    readonly brandId?: InputMaybe<Scalars['ID']['input']>
    readonly code: Scalars['String']['input']
    readonly email: Scalars['String']['input']
}

export interface InnovorderForgottenPasswordResponse {
    readonly brandId?: Maybe<Scalars['ID']['output']>
    readonly customerId?: Maybe<Scalars['ID']['output']>
    readonly message?: Maybe<Scalars['String']['output']>
    readonly status: Scalars['String']['output']
    readonly token: Scalars['String']['output']
}

export interface InnovorderLoginInput {
    readonly brandId?: InputMaybe<Scalars['ID']['input']>
    readonly password: Scalars['String']['input']
    readonly username: Scalars['String']['input']
}

export interface InnovorderMe {
    readonly firstName: Scalars['String']['output']
    readonly id: Scalars['ID']['output']
    readonly lastName: Scalars['String']['output']
}

export interface InnovorderMenu {
    readonly brandId?: Maybe<Scalars['ID']['output']>
    readonly createdAt?: Maybe<Scalars['DateTime']['output']>
    readonly hasInitModalBeenShowed?: Maybe<Scalars['Boolean']['output']>
    readonly imageId?: Maybe<Scalars['ID']['output']>
    readonly isEnabled?: Maybe<Scalars['Boolean']['output']>
    readonly isSyncFromPosEnabled?: Maybe<Scalars['Boolean']['output']>
    readonly menuId: Scalars['ID']['output']
    readonly name?: Maybe<Scalars['String']['output']>
    readonly restaurantId?: Maybe<Scalars['ID']['output']>
    readonly updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export interface InnovorderMenuTag {
    readonly brandId?: Maybe<Scalars['ID']['output']>
    readonly color: Scalars['String']['output']
    readonly isEnabled: Scalars['Boolean']['output']
    readonly name: Scalars['String']['output']
    readonly tagId: Scalars['ID']['output']
}

export interface InnovorderOrder {
    readonly channelId: Scalars['ID']['output']
    /** Present when Innovorder returns a non-final status such as required_action (3DS). */
    readonly code?: Maybe<Scalars['String']['output']>
    readonly currency: Scalars['String']['output']
    readonly customerId?: Maybe<Scalars['ID']['output']>
    readonly menuId: Scalars['ID']['output']
    readonly orderId: Scalars['ID']['output']
    /** 3DS / SCA challenge details when code is required_action. */
    readonly requiredAction?: Maybe<InnovorderRequiredAction>
    readonly restaurantId: Scalars['ID']['output']
}

export interface InnovorderOrderItemInput {
    readonly productId: Scalars['ID']['input']
    readonly quantity: Scalars['Int']['input']
}

export interface InnovorderPastOrder {
    readonly channel: InnovorderChannelEnum
    readonly currency: Scalars['String']['output']
    readonly id: Scalars['ID']['output']
    readonly items: ReadonlyArray<InnovorderPastOrderItem>
    readonly orderedAt: Scalars['DateTime']['output']
    readonly restaurantName?: Maybe<Scalars['String']['output']>
    readonly status: Scalars['String']['output']
    readonly ticketNumber?: Maybe<Scalars['String']['output']>
    readonly totalPrice: Scalars['Cent']['output']
}

export interface InnovorderPastOrderItem {
    readonly name: Scalars['String']['output']
    readonly quantity: Scalars['Int']['output']
    readonly totalPrice: Scalars['Cent']['output']
}

export interface InnovorderPaymentInput {
    readonly amount: Scalars['Int']['input']
    /** Saved Innovorder card id (integer). Takes precedence over stripePaymentMethodId when both are set. */
    readonly cardId?: InputMaybe<Scalars['Int']['input']>
    readonly paymentMethodId?: InputMaybe<Scalars['ID']['input']>
    readonly quantity: Scalars['Int']['input']
    /** Stripe PaymentMethod id (pm_…) for one-shot card payments. Backend encodes Innovorder metadata JSON string. */
    readonly stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>
}

export interface InnovorderPaymentMethod {
    readonly id: Scalars['ID']['output']
    readonly isActive: Scalars['Boolean']['output']
    readonly name: Scalars['String']['output']
    readonly position: Scalars['Int']['output']
}

export interface InnovorderProduct {
    readonly createdAt?: Maybe<Scalars['DateTime']['output']>
    readonly description?: Maybe<Scalars['String']['output']>
    readonly id: Scalars['ID']['output']
    readonly name?: Maybe<Scalars['String']['output']>
    readonly price?: Maybe<Scalars['Float']['output']>
    readonly sku?: Maybe<Scalars['String']['output']>
    readonly updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum InnovorderProductTagEnum {
    Admissionnable = 'ADMISSIONNABLE',
    Subventionnable = 'SUBVENTIONNABLE',
}

export interface InnovorderRequestForgottenPasswordCodeInput {
    readonly email: Scalars['String']['input']
}

export interface InnovorderRequestForgottenPasswordCodeResponse {
    readonly message?: Maybe<Scalars['String']['output']>
    readonly status: Scalars['String']['output']
}

export interface InnovorderRequiredAction {
    readonly intentId: Scalars['String']['output']
    readonly paymentIntentClientSecret: Scalars['String']['output']
    readonly requiresAction: Scalars['Boolean']['output']
    readonly type: Scalars['String']['output']
}

export interface InnovorderRestaurant {
    readonly country?: Maybe<Scalars['String']['output']>
    readonly id: Scalars['ID']['output']
    readonly latitude?: Maybe<Scalars['Float']['output']>
    readonly locality?: Maybe<Scalars['String']['output']>
    readonly longitude?: Maybe<Scalars['Float']['output']>
    readonly name: Scalars['String']['output']
    readonly postalCode?: Maybe<Scalars['String']['output']>
    /** Stripe Connect account id (acct_…) for 3DS challenges on the connected account. */
    readonly stripeUserId?: Maybe<Scalars['String']['output']>
    readonly timeZoneId?: Maybe<Scalars['String']['output']>
}

export interface InnovorderRestaurantLink {
    readonly brandId: Scalars['ID']['output']
    readonly id: Scalars['ID']['output']
    readonly publicStripeKey?: Maybe<Scalars['String']['output']>
    readonly restaurantId: Scalars['ID']['output']
    readonly webhookSecret?: Maybe<Scalars['String']['output']>
}

export interface InnovorderStripeConfig {
    readonly publicStripeKey?: Maybe<Scalars['String']['output']>
    readonly stripeAccountId?: Maybe<Scalars['String']['output']>
}

export interface InnovorderUpdateForgottenPasswordInput {
    readonly brandId: Scalars['ID']['input']
    readonly customerId: Scalars['ID']['input']
    readonly password: Scalars['String']['input']
    readonly password_confirmation: Scalars['String']['input']
    readonly token: Scalars['String']['input']
}

export interface InnovorderUpdateForgottenPasswordResponse {
    readonly message?: Maybe<Scalars['String']['output']>
    readonly status: Scalars['String']['output']
}

export interface InnovorderUpdateProductInput {
    readonly description: Scalars['String']['input']
    readonly externalProductId: Scalars['ID']['input']
    readonly name: Scalars['String']['input']
    readonly price: Scalars['Float']['input']
}

export enum IntegrationProviderEnum {
    Apicbase = 'APICBASE',
    Innovorder = 'INNOVORDER',
    InternalVoucher = 'INTERNAL_VOUCHER',
    Okta = 'OKTA',
    Planon = 'PLANON',
}

export interface InternalVoucher {
    readonly activeFrom: Scalars['DateTime']['output']
    readonly activeUntil: Scalars['DateTime']['output']
    readonly code: Scalars['String']['output']
    readonly deactivatedAt?: Maybe<Scalars['DateTime']['output']>
    readonly id: Scalars['ID']['output']
    readonly initialAmount: Scalars['Cent']['output']
    readonly logs?: Maybe<ReadonlyArray<VoucherLog>>
    readonly usedAmount: Scalars['Cent']['output']
    readonly user: User
}

export interface InternalVouchersFiltersInput {
    readonly activeFrom?: InputMaybe<Scalars['Date']['input']>
    readonly activeUntil?: InputMaybe<Scalars['Date']['input']>
    readonly clientId?: InputMaybe<Scalars['ID']['input']>
    readonly email?: InputMaybe<Scalars['String']['input']>
}

export interface InternalVouchersInput {
    readonly filters?: InputMaybe<InternalVouchersFiltersInput>
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface InternalVouchersPaginator {
    readonly data: ReadonlyArray<InternalVoucher>
    readonly paginatorInfo: PaginatorInfo
}

export interface IsRatedByUserInput {
    readonly consumptionDate: Scalars['Date']['input']
    readonly productId: Scalars['ID']['input']
    readonly type: DishRatingTypeEnum
}

export interface IsoWeek {
    readonly week: Scalars['IsoWeekNumber']['output']
    readonly year: Scalars['IsoWeekYear']['output']
}

export interface IsoWeekDate {
    readonly date: Scalars['Date']['output']
    readonly week: Scalars['IsoWeekNumber']['output']
    readonly weekday: WeekDayEnum
    readonly year: Scalars['IsoWeekYear']['output']
}

export interface IsoWeekDateInput {
    readonly week: Scalars['IsoWeekNumber']['input']
    readonly weekday: WeekDayEnum
    readonly year: Scalars['IsoWeekYear']['input']
}

export interface IsoWeekInput {
    readonly week: Scalars['IsoWeekNumber']['input']
    readonly year: Scalars['IsoWeekYear']['input']
}

export enum ItemSourceEnum {
    ApicBase = 'APIC_BASE',
    Internal = 'INTERNAL',
}

export interface LatestAppVersion {
    /** The latest Semver version of the Android app. */
    readonly android?: Maybe<Scalars['Semver']['output']>
    /** The latest Semver version of the IOS app. */
    readonly ios?: Maybe<Scalars['Semver']['output']>
}

export interface Locale {
    readonly name: Scalars['String']['output']
}

export interface Location {
    readonly cityName: Scalars['String']['output']
    readonly costCenter?: Maybe<Scalars['String']['output']>
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
    readonly postalCode: Scalars['String']['output']
    readonly restaurants: ReadonlyArray<Restaurant>
    readonly shortcode?: Maybe<Scalars['String']['output']>
    readonly streetName: Scalars['String']['output']
    readonly streetNumber: Scalars['String']['output']
}

export interface LocationBelongsTo {
    readonly connect: Scalars['ID']['input']
}

export interface LocationsFilterInput {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly query?: InputMaybe<Scalars['String']['input']>
}

export interface LocationsInput {
    readonly filters?: InputMaybe<LocationsFilterInput>
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface LocationsPaginator {
    readonly data: ReadonlyArray<Location>
    readonly paginatorInfo: PaginatorInfo
}

export interface LoginInput {
    readonly clientId: Scalars['ID']['input']
    readonly clientSecret: Scalars['String']['input']
    readonly isBackoffice?: InputMaybe<Scalars['Boolean']['input']>
    readonly password: Scalars['String']['input']
    readonly twoFactorCode?: InputMaybe<Scalars['String']['input']>
    readonly twoFactorRecoveryCode?: InputMaybe<Scalars['String']['input']>
    readonly username: Scalars['String']['input']
}

export interface LogoutResponse {
    readonly message?: Maybe<Scalars['String']['output']>
    readonly status: Scalars['String']['output']
}

export interface Menu {
    /**
   * The ISO-8601 compliant (with kept TZ offset) date-time lower-bound of the week this menu represents.
   * E.g. '2024-01-01T00:00:00.000000+01:00' for Week 1, 2024 in West European time zone.
   */
    readonly dateTimeLowerBound: Scalars['String']['output']
    /**
   * The ISO-8601 compliant (with kept TZ offset) date-time upper-bound of the week this menu represents.
   * E.g. '2024-01-07T23:59:59.999999+01:00' for Week 1, 2024 in West European time zone.
   */
    readonly dateTimeUpperBound: Scalars['String']['output']
    readonly dates: MenuDates
    readonly entries: ReadonlyArray<MenuEntry>
    readonly id: Scalars['ID']['output']
    readonly isPublished: Scalars['Boolean']['output']
    readonly isoWeekNotation: Scalars['String']['output']
    readonly isoWeekNumber: Scalars['IsoWeekNumber']['output']
    readonly isoWeekYear: Scalars['IsoWeekYear']['output']
    /**
   * When the menu is published, this contains the log of the publishing
   * process. This is a JSON string and can be quite large!
   */
    readonly publicationLog?: Maybe<Scalars['String']['output']>
}

export interface MenuDates {
    readonly FRIDAY: DateNotations
    readonly MONDAY: DateNotations
    readonly SATURDAY: DateNotations
    readonly SUNDAY: DateNotations
    readonly THURSDAY: DateNotations
    readonly TUESDAY: DateNotations
    readonly WEDNESDAY: DateNotations
}

export interface MenuEntriesQueryFilter {
    readonly creationSources?: InputMaybe<ReadonlyArray<CreationSourceEnum>>
    readonly productCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly productTypes?: InputMaybe<ReadonlyArray<ProductTypeEnum>>
    readonly tags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export interface MenuEntry {
    readonly creationSource: CreationSourceEnum
    readonly date: Scalars['Date']['output']
    readonly id: Scalars['ID']['output']
    /** @deprecated Can be derived from 'weekday'. This attribute will be removed in the future. */
    readonly isoDayNumber: Scalars['IsoDayNumber']['output']
    readonly menu: Menu
    readonly occurrences: ReadonlyArray<MenuEntryOccurrence>
    readonly position: Scalars['Int']['output']
    readonly product: Product
    readonly tags: ReadonlyArray<MenuEntryTag>
    readonly weekday: WeekDayEnum
}

export interface MenuEntryCreationInput {
    readonly menuId: Scalars['ID']['input']
    readonly productId: Scalars['ID']['input']
    readonly weekday: WeekDayEnum
}

export interface MenuEntryOccurrence {
    /** Audit log of ad-hoc servings for this occurrence (newest first). */
    readonly adhocServings: ReadonlyArray<AdhocServing>
    readonly creationSource: CreationSourceEnum
    readonly entry: MenuEntry
    readonly entryId: Scalars['ID']['output']
    readonly id: Scalars['ID']['output']
    readonly innovorderTags: ReadonlyArray<InnovorderProductTagEnum>
    readonly position: Scalars['Int']['output']
    readonly prices: ReadonlyArray<MenuEntryOccurrencePrice>
    readonly restaurant: Restaurant
    /**
   * Denormalized count of items issued ad-hoc via kitchen/backoffice updateStock(ISSUE_AVAILABLE),
   * without an order. Separate from stockIssued, which also includes order pickups.
   */
    readonly stockAdhocIssued: Scalars['Int']['output']
    readonly stockClaimed: Scalars['Int']['output']
    readonly stockIssued: Scalars['Int']['output']
    readonly stockTotalCorrection: Scalars['Int']['output']
    readonly stockTotalInitial?: Maybe<Scalars['Int']['output']>
}

export interface MenuEntryOccurrenceInput {
    readonly menuEntryId: Scalars['ID']['input']
    readonly prices: ReadonlyArray<MenuEntryOccurrencePriceInput>
    readonly stockTotalInitial?: InputMaybe<Scalars['Int']['input']>
}

export interface MenuEntryOccurrencePositioningInput {
    readonly menuEntryOccurrenceId: Scalars['ID']['input']
    readonly position: Scalars['Int']['input']
}

export interface MenuEntryOccurrencePrice {
    readonly client: Client
    readonly id: Scalars['ID']['output']
    readonly occurrence: MenuEntryOccurrence
    readonly sellingPrice: Scalars['Cent']['output']
}

export interface MenuEntryOccurrencePriceInput {
    readonly clientId: Scalars['ID']['input']
    readonly sellingPrice: Scalars['Cent']['input']
}

export interface MenuEntryOccurrencesQueryFilter {
    readonly creationSources?: InputMaybe<ReadonlyArray<CreationSourceEnum>>
    readonly entries?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export interface MenuEntryPositioningInput {
    readonly menuEntryId: Scalars['ID']['input']
    readonly position: Scalars['Int']['input']
}

export interface MenuEntryTag {
    readonly entries: ReadonlyArray<MenuEntry>
    readonly hexColor: Scalars['String']['output']
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
}

export interface MenuEntryTagChanges {
    readonly attached: ReadonlyArray<Scalars['ID']['output']>
    readonly detached: ReadonlyArray<Scalars['ID']['output']>
    readonly updated: ReadonlyArray<Scalars['ID']['output']>
}

export interface MenuEntryTagResult {
    readonly changes: MenuEntryTagChanges
    readonly menuEntryId: Scalars['ID']['output']
}

export interface Mutation {
    /**
   * Assigns the given list of Client associations to the Restaurant by given ID.
   *
   * ---
   *
   * The input data is considered the **complete set of associations**. If a pivot record already exists
   * for one of the given associations, the provided auxiliary data overrides corresponding data on the
   * existing pivot record. If it does not exist, a new association will be created. The mutation also
   * deletes associations that pre-exist at call time but are not included in the mutation input data.
   */
    readonly assignClientsToRestaurant: RestaurantWithClientAssociations
    readonly assignProductCategoriesToRestaurant: RestaurantWithProductCategories
    readonly assignProductCategoryPricesToClient: ReadonlyArray<ProductCategoryPrice>
    /**
   * Assigns the given set of occurrences with stock and selling-price information to the restaurant by given ID
   * for the week by given ISO week parameters.
   *
   * The input data is considered the **complete set of occurrences**. If a MenuEntryOccurrence already exists
   * for one of the given occurrences, the provided data is patched on the existing record and its related price
   * records. If it does not exist, a new one will be created. Existing occurrences that are not repeated in the
   * input data are deleted while that does not compromise the menu integrity. Throws a validation error otherwise.
   */
    readonly assignRestaurantMenu: ReadonlyArray<MenuEntryOccurrence>
    /**
   * Assigns the given list of Restaurant associations to the Client by given ID.
   *
   * ---
   *
   * The input data is considered the **complete set of associations**. If a pivot record already exists
   * for one of the given associations, the provided auxiliary data overrides corresponding data on the
   * existing pivot record. If it does not exist, a new association will be created. The mutation also
   * deletes associations that pre-exist at call time but are not included in the mutation input data.
   */
    readonly assignRestaurantsToClient: ClientWithRestaurantAssociations
    readonly associateExternalCategory: ExternalCategory
    readonly cancelInnovorderOrder: Order
    readonly cancelOrder: Order
    /**
   * Confirms an Innovorder order after a Stripe 3DS / SCA challenge.
   *
   * Call this after handling `requiredAction` from `createInnovorderOrder`
   * with the same `orderId` and the PaymentIntent id from `requiredAction.intentId`.
   */
    readonly confirmInnovorderOrder: InnovorderOrder
    readonly createAnswer: Answer
    readonly createCategory: Category
    readonly createClient: Client
    readonly createClosedDate: ClosedDate
    readonly createContentMedia: ContentMedia
    readonly createDailyGuestEstimation: DailyGuestEstimation
    readonly createDishRating: DishRating
    readonly createDismissRating: DismissedRating
    readonly createDomains: ReadonlyArray<Domain>
    readonly createInnovorderMenuTag: InnovorderMenuTag
    readonly createInnovorderOrder: InnovorderOrder
    readonly createInnovorderProduct: InnovorderProduct
    readonly createInternalVoucher?: Maybe<InternalVoucher>
    readonly createLocation: Location
    readonly createLoginSession: CreateLoginSessionResponse
    readonly createMenuEntries: ReadonlyArray<MenuEntry>
    /**
   * Creates a new menu-entry tag with the given name and HEX color values.
   * The given name must be unique.
   */
    readonly createMenuEntryTag: MenuEntryTag
    readonly createNarrowcastingTablet: NarrowcastingTablet
    readonly createNarrowcastingTabletSchedule: NarrowcastingTabletSchedule
    readonly createNewsItem: NewsItem
    readonly createOrUpdateClientTheme?: Maybe<ClientTheme>
    /**
   * Creates one or multiple orders for the given input. Returns the list of created orders upon success.
   * When called with an empty list this mutation will fail.
   */
    readonly createOrders: ReadonlyArray<Order>
    readonly createPayment: Payment
    readonly createPoll: Question
    /**
   * Creates one or multiple orders for POS (point-of-sale) without timeslot selection.
   * Use this for over-the-counter sales where orders are fulfilled immediately.
   * Does not require fetching or validating timeslots; transferDate defaults to today when omitted.
   */
    readonly createPosOrders: ReadonlyArray<Order>
    readonly createProduct: Product
    readonly createProductCategory?: Maybe<ProductCategory>
    readonly createPublicCategory: PublicCategory
    readonly createRestaurant: Restaurant
    readonly createTag: Tag
    readonly createTapToPayPosPayment: PaymentInitResult
    readonly createTemplateMenu: TemplateMenu
    readonly createTemplateMenuEntries: ReadonlyArray<TemplateMenuEntry>
    /**
   * Create a timeslot template-set for the restaurant by given ID. This field throws if one already
   * exists; restaurants can have only one set.
   */
    readonly createTimeslotTemplateSet: TimeslotTemplateSet
    readonly createUser: User
    readonly deActivateInternalVoucher?: Maybe<Scalars['Boolean']['output']>
    readonly deleteAndReplacePrivateCategory: Scalars['Boolean']['output']
    readonly deleteClient?: Maybe<Scalars['Boolean']['output']>
    readonly deleteClosedDate: Scalars['Boolean']['output']
    readonly deleteDailyGuestEstimation: Scalars['Boolean']['output']
    readonly deleteDomain: Scalars['Boolean']['output']
    readonly deleteFileExport?: Maybe<Scalars['Boolean']['output']>
    readonly deleteInternalVoucher?: Maybe<Scalars['Boolean']['output']>
    readonly deleteMe: Scalars['Boolean']['output']
    /**
   * Deletes the menu-entries by given IDs. Only entries of unpublished menus may be deleted like this. This
   * endpoint will throw when any of the given IDs is of a published entry.
   */
    readonly deleteMenuEntries: Scalars['Boolean']['output']
    readonly deleteMenuEntryOccurrence: Scalars['Boolean']['output']
    /** Deletes the tag by given ID. */
    readonly deleteMenuEntryTag: Scalars['Boolean']['output']
    readonly deleteNarrowcastingTablet: Scalars['Boolean']['output']
    readonly deleteNarrowcastingTabletSchedule: Scalars['Boolean']['output']
    readonly deleteNewsItem: Scalars['Boolean']['output']
    readonly deletePoll: Scalars['Boolean']['output']
    readonly deleteProduct: Scalars['Boolean']['output']
    readonly deleteTag: Scalars['Boolean']['output']
    /** Deletes the template menu that currently exists by the given ID. */
    readonly deleteTemplateMenu: Scalars['Boolean']['output']
    /** Deletes the template menu-entries that currently exist by the given IDs. Returns true upon success. */
    readonly deleteTemplateMenuEntries: Scalars['Boolean']['output']
    /** Delete the timeslot template-set by the given ID. */
    readonly deleteTimeslotTemplateSet: Scalars['Boolean']['output']
    readonly deleteUser: Scalars['Boolean']['output']
    readonly disableTwoFactorAuthentication: Scalars['Boolean']['output']
    readonly ensureInnovorderMenuTags: ReadonlyArray<InnovorderMenuTag>
    readonly finishLoginSession: AuthPayload
    readonly forgotPassword: Scalars['String']['output']
    readonly generateDishRatingAveragesExport: FileExportInputResponse
    readonly generateDishRatingsExport: FileExportInputResponse
    /** Generate a file-export for the financial overview of orders. */
    readonly generateFinancialOrdersExport: FileExportInputResponse
    /** Generate a file-export for the given internal-orders. */
    readonly generateOrderExport: FileExportInputResponse
    readonly generateOrderSheetsExport: FileExportInputResponse
    readonly generatePollExport: FileExportInputResponse
    /** Generate a file-export for the voucher usage for the given client and datespan. */
    readonly generateVoucherUsageExport: FileExportInputResponse
    readonly innovorderForgottenPassword: InnovorderForgottenPasswordResponse
    readonly innovorderRequestForgottenPasswordCode: InnovorderRequestForgottenPasswordCodeResponse
    readonly innovorderUpdateForgottenPassword: InnovorderUpdateForgottenPasswordResponse
    readonly linkInnovorderBrandToClient: InnovorderClientLink
    readonly linkInnovorderRestaurant: InnovorderRestaurantLink
    readonly login: AuthPayload
    readonly loginWithInnovorder: AuthPayload
    readonly logout: LogoutResponse
    readonly pickUpOrder: Order
    readonly publishMenu: Menu
    readonly refreshToken: RefreshTokenPayload
    readonly register: RegisterResponse
    readonly savePurchaseOrder: PurchaseOrder
    readonly sendResetPasswordEmail: Scalars['Boolean']['output']
    readonly sendResetPasswordEmailToUser: Scalars['Boolean']['output']
    readonly setOrderStatus: OrderStatusUpdateReport
    readonly shortcodeRegister: RegisterResponse
    readonly sortMenuEntries: ReadonlyArray<MenuEntry>
    /**
   * Takes a restaurant ID and a date as a scope for a sortable set of occurrences, and then a
   * list of positions matching each occurrence (by ID) with a position. It saves the given positions
   * to the system. Note that ALL occurrences that associate with the given restaurant and date must
   * be represented in the positions list, otherwise the mutation will fail.
   */
    readonly sortMenuEntryOccurrences: ReadonlyArray<MenuEntryOccurrence>
    readonly sortTemplateMenuEntries: ReadonlyArray<TemplateMenuEntry>
    readonly syncInnovorderProducts: Scalars['Boolean']['output']
    readonly syncMenu: InnovorderMenu
    readonly tagMenuEntries: ReadonlyArray<MenuEntryTagResult>
    readonly tagMenuEntryOccurrences: ReadonlyArray<MenuEntryOccurrence>
    readonly twoFactorAuthenticationConfirm: ReadonlyArray<Scalars['String']['output']>
    readonly twoFactorAuthenticationDisable?: Maybe<Scalars['Boolean']['output']>
    readonly twoFactorAuthenticationEnable: TwoFactorSecret
    readonly unblockUser: User
    readonly unlinkInnovorderBrandFromClient: Scalars['Boolean']['output']
    readonly unlinkInnovorderRestaurant: Scalars['Boolean']['output']
    readonly updateAllergen?: Maybe<Allergen>
    readonly updateClient: Client
    readonly updateClosedDate: ClosedDate
    readonly updateDailyGuestEstimation: DailyGuestEstimation
    readonly updateForgottenPassword: ForgotPasswordResponse
    readonly updateInnovorderProduct: InnovorderProduct
    readonly updateInnovorderRestaurantPublicStripeKey: InnovorderRestaurantLink
    readonly updateInnovorderRestaurantWebhookSecret: InnovorderRestaurantLink
    readonly updateInternalVoucher?: Maybe<InternalVoucher>
    readonly updateLocation: Location
    readonly updateMe: User
    /**
   * Updates the tag by given ID with the given name and HEX color values.
   * The given name must be unique.
   */
    readonly updateMenuEntryTag: MenuEntryTag
    readonly updateNarrowcastingTablet: NarrowcastingTablet
    readonly updateNarrowcastingTabletSchedule: NarrowcastingTabletSchedule
    readonly updateNewsItem: NewsItem
    /**
   * Updates the prices of a menu-entry-occurrence. For each client that is served by the occurrence's restaurant
   * exactly one price input is required.
   */
    readonly updateOccurrencePrices: MenuEntryOccurrence
    readonly updateOfficeDays: ReadonlyArray<OfficeDay>
    readonly updatePassword: UpdatePasswordResponse
    readonly updatePoll: Question
    readonly updateProduct: Product
    readonly updateProductCategory?: Maybe<ProductCategory>
    readonly updatePublicCategory: PublicCategory
    readonly updateRestaurant: Restaurant
    readonly updateRestaurantOpeningHours: Restaurant
    readonly updateStock: UpdateStockResponse
    readonly updateTag: Tag
    readonly updateTemplateMenuEntries: ReadonlyArray<TemplateMenuEntry>
    /** Update the timeslot template-set by the given ID. */
    readonly updateTimeslotTemplateSet: TimeslotTemplateSet
    readonly updateUser: User
    readonly updateUserAllergens: User
    readonly verifyEmail: AuthPayload
    readonly verifyPayment: Payment
}


export interface MutationAssignClientsToRestaurantArgs {
    associations: ReadonlyArray<RestaurantClientAssociationInput>
    restaurantId: Scalars['ID']['input']
}


export interface MutationAssignProductCategoriesToRestaurantArgs {
    input: AssignProductCategoriesToRestaurantInput
}


export interface MutationAssignProductCategoryPricesToClientArgs {
    input: AssignProductCategoryPricesToClientInput
}


export interface MutationAssignRestaurantMenuArgs {
    isoWeekNumber: Scalars['IsoWeekNumber']['input']
    isoWeekYear: Scalars['IsoWeekYear']['input']
    occurrences: ReadonlyArray<MenuEntryOccurrenceInput>
    restaurantId: Scalars['ID']['input']
}


export interface MutationAssignRestaurantsToClientArgs {
    associations: ReadonlyArray<ClientRestaurantAssociationInput>
    clientId: Scalars['ID']['input']
}


export interface MutationAssociateExternalCategoryArgs {
    externalCategory: Scalars['ID']['input']
    privateCategory: Scalars['ID']['input']
}


export interface MutationCancelInnovorderOrderArgs {
    orderID: Scalars['ID']['input']
}


export interface MutationCancelOrderArgs {
    orderID: Scalars['ID']['input']
}


export interface MutationConfirmInnovorderOrderArgs {
    brandId?: InputMaybe<Scalars['ID']['input']>
    orderId: Scalars['ID']['input']
    paymentIntentId: Scalars['String']['input']
}


export interface MutationCreateAnswerArgs {
    input: CreateAnswerInput
}


export interface MutationCreateCategoryArgs {
    brandId: Scalars['ID']['input']
    input: CreateCategoryInput
    menuId: Scalars['ID']['input']
}


export interface MutationCreateClientArgs {
    input: CreateClientInput
}


export interface MutationCreateClosedDateArgs {
    input: CreateClosedDateInput
}


export interface MutationCreateContentMediaArgs {
    media: Scalars['Upload']['input']
}


export interface MutationCreateDailyGuestEstimationArgs {
    input: CreateDailyGuestEstimationInput
}


export interface MutationCreateDishRatingArgs {
    input: CreateDishRatingInput
}


export interface MutationCreateDismissRatingArgs {
    input: CreateDismissRatingInput
}


export interface MutationCreateDomainsArgs {
    input: CreateDomainInput
}


export interface MutationCreateInnovorderMenuTagArgs {
    brandId: Scalars['ID']['input']
    input: CreateInnovorderMenuTagInput
    menuId: Scalars['ID']['input']
}


export interface MutationCreateInnovorderOrderArgs {
    brandId?: InputMaybe<Scalars['ID']['input']>
    cart: ReadonlyArray<InnovorderOrderItemInput>
    date?: InputMaybe<Scalars['Date']['input']>
    payments: ReadonlyArray<InnovorderPaymentInput>
    restaurantId: Scalars['ID']['input']
}


export interface MutationCreateInnovorderProductArgs {
    brandId: Scalars['ID']['input']
    menuId: Scalars['ID']['input']
    productId: Scalars['ID']['input']
}


export interface MutationCreateInternalVoucherArgs {
    input: CreateInternalVoucherInput
}


export interface MutationCreateLocationArgs {
    input: CreateLocationInput
}


export interface MutationCreateLoginSessionArgs {
    input: CreateLoginSessionInput
}


export interface MutationCreateMenuEntriesArgs {
    entries: ReadonlyArray<MenuEntryCreationInput>
}


export interface MutationCreateMenuEntryTagArgs {
    hexColor: Scalars['String']['input']
    name: Scalars['String']['input']
}


export interface MutationCreateNarrowcastingTabletArgs {
    input: CreateNarrowcastingTabletInput
}


export interface MutationCreateNarrowcastingTabletScheduleArgs {
    input: CreateNarrowcastingTabletScheduleInput
}


export interface MutationCreateNewsItemArgs {
    input: NewsItemInput
}


export interface MutationCreateOrUpdateClientThemeArgs {
    clientId: Scalars['ID']['input']
    input?: InputMaybe<UpdateClientThemeInput>
}


export interface MutationCreateOrdersArgs {
    orders: ReadonlyArray<OrderCreationInput>
}


export interface MutationCreatePaymentArgs {
    orderIds: ReadonlyArray<Scalars['ID']['input']>
    vouchers?: InputMaybe<ReadonlyArray<VoucherUsageInput>>
}


export interface MutationCreatePollArgs {
    input: CreatePollInput
}


export interface MutationCreatePosOrdersArgs {
    orders: ReadonlyArray<PosOrderCreationInput>
}


export interface MutationCreateProductArgs {
    input: CreateProductInput
}


export interface MutationCreateProductCategoryArgs {
    input: CreateProductCategoryInput
}


export interface MutationCreatePublicCategoryArgs {
    input: CreatePublicCategoryInput
}


export interface MutationCreateRestaurantArgs {
    input: CreateRestaurantInput
}


export interface MutationCreateTagArgs {
    translations?: InputMaybe<ReadonlyArray<TagTranslationInput>>
}


export interface MutationCreateTapToPayPosPaymentArgs {
    amount: Scalars['Cent']['input']
    currency: CurrencyEnum
    orderId: Scalars['ID']['input']
    terminalId?: InputMaybe<Scalars['String']['input']>
}


export interface MutationCreateTemplateMenuArgs {
    restaurantId: Scalars['ID']['input']
}


export interface MutationCreateTemplateMenuEntriesArgs {
    entries: ReadonlyArray<TemplateMenuEntryCreationInput>
}


export interface MutationCreateTimeslotTemplateSetArgs {
    input: TimeslotTemplateSetInput
    restaurantId: Scalars['ID']['input']
}


export interface MutationCreateUserArgs {
    input: CreateUserInput
}


export interface MutationDeActivateInternalVoucherArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteAndReplacePrivateCategoryArgs {
    originalId: Scalars['ID']['input']
    replacementId: Scalars['ID']['input']
}


export interface MutationDeleteClientArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteClosedDateArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteDailyGuestEstimationArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteDomainArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteFileExportArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteInternalVoucherArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteMenuEntriesArgs {
    ids: ReadonlyArray<Scalars['ID']['input']>
}


export interface MutationDeleteMenuEntryOccurrenceArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteMenuEntryTagArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteNarrowcastingTabletArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteNarrowcastingTabletScheduleArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteNewsItemArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeletePollArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteProductArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteTagArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteTemplateMenuArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteTemplateMenuEntriesArgs {
    ids: ReadonlyArray<Scalars['ID']['input']>
}


export interface MutationDeleteTimeslotTemplateSetArgs {
    id: Scalars['ID']['input']
}


export interface MutationDeleteUserArgs {
    id: Scalars['ID']['input']
}


export interface MutationDisableTwoFactorAuthenticationArgs {
    userId: Scalars['ID']['input']
}


export interface MutationEnsureInnovorderMenuTagsArgs {
    brandId: Scalars['ID']['input']
    menuId: Scalars['ID']['input']
}


export interface MutationFinishLoginSessionArgs {
    input: FinishLoginSessionInput
}


export interface MutationForgotPasswordArgs {
    email: Scalars['String']['input']
}


export interface MutationGenerateDishRatingAveragesExportArgs {
    input: DishRatingAveragesInput
}


export interface MutationGenerateDishRatingsExportArgs {
    input: DishRatingsExportInput
}


export interface MutationGenerateFinancialOrdersExportArgs {
    input: FinancialOrdersExportInput
}


export interface MutationGenerateOrderExportArgs {
    input: OrderExportInput
}


export interface MutationGenerateOrderSheetsExportArgs {
    input: OrderSheetsExportInput
}


export interface MutationGeneratePollExportArgs {
    input: PollExportInput
}


export interface MutationGenerateVoucherUsageExportArgs {
    input: VoucherUsageExportInput
}


export interface MutationInnovorderForgottenPasswordArgs {
    input: InnovorderForgottenPasswordInput
}


export interface MutationInnovorderRequestForgottenPasswordCodeArgs {
    input: InnovorderRequestForgottenPasswordCodeInput
}


export interface MutationInnovorderUpdateForgottenPasswordArgs {
    input: InnovorderUpdateForgottenPasswordInput
}


export interface MutationLinkInnovorderBrandToClientArgs {
    brandId: Scalars['ID']['input']
    clientId: Scalars['ID']['input']
}


export interface MutationLinkInnovorderRestaurantArgs {
    publicStripeKey?: InputMaybe<Scalars['String']['input']>
    restaurantId: Scalars['ID']['input']
    webhookSecret?: InputMaybe<Scalars['String']['input']>
}


export interface MutationLoginArgs {
    input?: InputMaybe<LoginInput>
}


export interface MutationLoginWithInnovorderArgs {
    input?: InputMaybe<InnovorderLoginInput>
}


export interface MutationPickUpOrderArgs {
    input: PickUpOrderInput
}


export interface MutationPublishMenuArgs {
    id: Scalars['ID']['input']
}


export interface MutationRefreshTokenArgs {
    input?: InputMaybe<RefreshTokenInput>
}


export interface MutationRegisterArgs {
    input?: InputMaybe<RegisterInput>
}


export interface MutationSavePurchaseOrderArgs {
    input: SavePurchaseOrderInput
}


export interface MutationSendResetPasswordEmailArgs {
    input: SendResetPasswordEmailInput
}


export interface MutationSendResetPasswordEmailToUserArgs {
    user: Scalars['ID']['input']
}


export interface MutationSetOrderStatusArgs {
    orderID: Scalars['ID']['input']
    status: OrderStatusEnum
}


export interface MutationShortcodeRegisterArgs {
    input?: InputMaybe<ShortcodeRegisterInput>
}


export interface MutationSortMenuEntriesArgs {
    date: Scalars['Date']['input']
    positions: ReadonlyArray<MenuEntryPositioningInput>
}


export interface MutationSortMenuEntryOccurrencesArgs {
    date: Scalars['Date']['input']
    positions: ReadonlyArray<MenuEntryOccurrencePositioningInput>
    restaurantId: Scalars['ID']['input']
}


export interface MutationSortTemplateMenuEntriesArgs {
    positions: ReadonlyArray<TemplateMenuEntryPositionInput>
    templateMenuId: Scalars['ID']['input']
}


export interface MutationSyncInnovorderProductsArgs {
    brandId?: InputMaybe<Scalars['ID']['input']>
    isoDay?: InputMaybe<Scalars['IsoDayNumber']['input']>
    restaurantId?: InputMaybe<Scalars['ID']['input']>
}


export interface MutationSyncMenuArgs {
    brandId: Scalars['ID']['input']
    channels: ReadonlyArray<Scalars['ID']['input']>
    internalMenuId?: InputMaybe<Scalars['ID']['input']>
    name: Scalars['String']['input']
    restaurantId: Scalars['ID']['input']
}


export interface MutationTagMenuEntriesArgs {
    entries: ReadonlyArray<Scalars['ID']['input']>
    tagStrategy: TagStrategyEnum
    tags: ReadonlyArray<Scalars['ID']['input']>
}


export interface MutationTagMenuEntryOccurrencesArgs {
    occurrences: ReadonlyArray<Scalars['ID']['input']>
    tagStrategy: TagStrategyEnum
    tags: ReadonlyArray<InnovorderProductTagEnum>
}


export interface MutationTwoFactorAuthenticationConfirmArgs {
    input?: InputMaybe<TwoFactorAuthenticationConfirmInput>
}


export interface MutationTwoFactorAuthenticationEnableArgs {
    input?: InputMaybe<TwoFactorAuthenticationEnableInput>
}


export interface MutationUnblockUserArgs {
    userId: Scalars['ID']['input']
}


export interface MutationUnlinkInnovorderBrandFromClientArgs {
    brandId: Scalars['ID']['input']
    clientId: Scalars['ID']['input']
}


export interface MutationUnlinkInnovorderRestaurantArgs {
    restaurantId: Scalars['ID']['input']
}


export interface MutationUpdateAllergenArgs {
    input: UpdateAllergenInput
}


export interface MutationUpdateClientArgs {
    input: UpdateClientInput
}


export interface MutationUpdateClosedDateArgs {
    input: UpdateClosedDateInput
}


export interface MutationUpdateDailyGuestEstimationArgs {
    input: UpdateDailyGuestEstimationInput
}


export interface MutationUpdateForgottenPasswordArgs {
    input?: InputMaybe<NewPasswordWithCodeInput>
}


export interface MutationUpdateInnovorderProductArgs {
    brandId: Scalars['ID']['input']
    input: InnovorderUpdateProductInput
    menuId: Scalars['ID']['input']
}


export interface MutationUpdateInnovorderRestaurantPublicStripeKeyArgs {
    publicStripeKey: Scalars['String']['input']
    restaurantId: Scalars['ID']['input']
}


export interface MutationUpdateInnovorderRestaurantWebhookSecretArgs {
    restaurantId: Scalars['ID']['input']
    webhookSecret: Scalars['String']['input']
}


export interface MutationUpdateInternalVoucherArgs {
    input: UpdateInternalVoucherInput
}


export interface MutationUpdateLocationArgs {
    input: UpdateLocationInput
}


export interface MutationUpdateMeArgs {
    input: UpdateMeInput
}


export interface MutationUpdateMenuEntryTagArgs {
    hexColor: Scalars['String']['input']
    id: Scalars['ID']['input']
    name: Scalars['String']['input']
}


export interface MutationUpdateNarrowcastingTabletArgs {
    id: Scalars['ID']['input']
    input: UpdateNarrowcastingTabletInput
}


export interface MutationUpdateNarrowcastingTabletScheduleArgs {
    id: Scalars['ID']['input']
    input: UpdateNarrowcastingTabletScheduleInput
}


export interface MutationUpdateNewsItemArgs {
    id: Scalars['ID']['input']
    input: NewsItemInput
}


export interface MutationUpdateOccurrencePricesArgs {
    menuEntryOccurrenceId: Scalars['ID']['input']
    prices: ReadonlyArray<MenuEntryOccurrencePriceInput>
}


export interface MutationUpdateOfficeDaysArgs {
    input: ChangeOfficeDaysInput
}


export interface MutationUpdatePasswordArgs {
    input: UpdatePassword
}


export interface MutationUpdatePollArgs {
    input: UpdatePollInput
}


export interface MutationUpdateProductArgs {
    input: UpdateProductInput
}


export interface MutationUpdateProductCategoryArgs {
    input: UpdateProductCategoryInput
}


export interface MutationUpdatePublicCategoryArgs {
    input: UpdatePublicCategoryInput
}


export interface MutationUpdateRestaurantArgs {
    input: UpdateRestaurantInput
}


export interface MutationUpdateRestaurantOpeningHoursArgs {
    openingHours: ReadonlyArray<RestaurantOpeningHoursInput>
    restaurantId: Scalars['ID']['input']
}


export interface MutationUpdateStockArgs {
    menuEntryOccurrenceID: Scalars['ID']['input']
    mutationQuantity: Scalars['Int']['input']
    mutationType: StockMutationTypeEnum
}


export interface MutationUpdateTagArgs {
    id: Scalars['ID']['input']
    translations: ReadonlyArray<TagTranslationInput>
}


export interface MutationUpdateTemplateMenuEntriesArgs {
    entries: ReadonlyArray<TemplateMenuEntryUpdateInput>
    templateMenuId: Scalars['ID']['input']
}


export interface MutationUpdateTimeslotTemplateSetArgs {
    id: Scalars['ID']['input']
    input: TimeslotTemplateSetInput
}


export interface MutationUpdateUserArgs {
    input: UpdateUserInput
}


export interface MutationUpdateUserAllergensArgs {
    input: UpdateUserAllergensInput
}


export interface MutationVerifyEmailArgs {
    input: VerifyEmailInput
}


export interface MutationVerifyPaymentArgs {
    id: Scalars['ID']['input']
}

export enum NarrowcastingDisplayTemplateEnum {
    MultiDishes = 'MULTI_DISHES',
    SingleProduct = 'SINGLE_PRODUCT',
    TextMenu = 'TEXT_MENU',
}

export interface NarrowcastingTablet {
    readonly createdAt: Scalars['DateTime']['output']
    readonly displayCode: Scalars['String']['output']
    readonly id: Scalars['ID']['output']
    readonly name?: Maybe<Scalars['String']['output']>
    readonly schedules: ReadonlyArray<NarrowcastingTabletSchedule>
    readonly updatedAt: Scalars['DateTime']['output']
}

export interface NarrowcastingTabletSchedule {
    readonly endDate: Scalars['Date']['output']
    readonly id: Scalars['ID']['output']
    readonly products: ReadonlyArray<Product>
    readonly startDate: Scalars['Date']['output']
    readonly tablet: NarrowcastingTablet
    readonly template: NarrowcastingDisplayTemplateEnum
}

export interface NarrowcastingTabletsInput {
    readonly pagination: PaginationInput
}

export interface NarrowcastingTabletsPaginator {
    readonly data: ReadonlyArray<NarrowcastingTablet>
    readonly paginatorInfo: PaginatorInfo
}

export interface NewPasswordWithCodeInput {
    readonly email: Scalars['String']['input']
    readonly password: Scalars['String']['input']
    readonly password_confirmation: Scalars['String']['input']
    readonly token: Scalars['String']['input']
}

export interface NewsItem {
    readonly clients: ReadonlyArray<Client>
    readonly content?: Maybe<Scalars['String']['output']>
    readonly contentMedia: ReadonlyArray<ContentMedia>
    readonly createdAt: Scalars['DateTime']['output']
    readonly endDate?: Maybe<Scalars['DateTime']['output']>
    readonly highlightedImage?: Maybe<ContentMedia>
    readonly id: Scalars['ID']['output']
    readonly intro?: Maybe<Scalars['String']['output']>
    readonly publishedAt?: Maybe<Scalars['DateTime']['output']>
    readonly title?: Maybe<Scalars['String']['output']>
    readonly translations: ReadonlyArray<NewsItemTranslation>
    readonly updatedAt: Scalars['DateTime']['output']
}

export interface NewsItemInput {
    readonly clients: ReadonlyArray<Scalars['ID']['input']>
    readonly contentMedia: ReadonlyArray<Scalars['ID']['input']>
    readonly endDate?: InputMaybe<Scalars['DateTime']['input']>
    readonly highlightedImage?: InputMaybe<Scalars['ID']['input']>
    readonly publishedAt?: InputMaybe<Scalars['DateTime']['input']>
    readonly translations: ReadonlyArray<NewsItemTranslationInput>
}

export interface NewsItemTranslation {
    readonly content?: Maybe<Scalars['String']['output']>
    readonly intro?: Maybe<Scalars['String']['output']>
    readonly locale: Scalars['String']['output']
    readonly title?: Maybe<Scalars['String']['output']>
}

export interface NewsItemTranslationInput {
    readonly content?: InputMaybe<Scalars['String']['input']>
    readonly intro?: InputMaybe<Scalars['String']['input']>
    readonly locale: Scalars['String']['input']
    readonly title?: InputMaybe<Scalars['String']['input']>
}

export interface NewsItemsInput {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly endDateTime?: InputMaybe<Scalars['DateTime']['input']>
    readonly pagination: PaginationInput
    readonly searchQuery?: InputMaybe<Scalars['String']['input']>
    readonly sorting?: InputMaybe<SortingInput>
    readonly startDateTime?: InputMaybe<Scalars['DateTime']['input']>
}

export interface NewsItemsPaginator {
    readonly data: ReadonlyArray<NewsItem>
    readonly paginatorInfo: PaginatorInfo
}

export interface Nutrient {
    readonly NutrientType?: Maybe<NutrientType>
    readonly ProductVersion?: Maybe<ProductVersion>
    readonly perHundredGram?: Maybe<Scalars['Float']['output']>
}

export interface NutrientType {
    readonly id: Scalars['ID']['output']
    readonly isMacro: Scalars['Boolean']['output']
    readonly name: Scalars['String']['output']
    readonly position: Scalars['Int']['output']
    readonly translations: ReadonlyArray<NutrientTypeTranslation>
    readonly unit: NutrientTypeUnitEnum
}

export interface NutrientTypeTranslation {
    readonly locale: Scalars['String']['output']
    readonly name: Scalars['String']['output']
}

export interface NutrientTypeTranslationInput {
    readonly locale: Scalars['String']['input']
    readonly name: Scalars['String']['input']
}

export enum NutrientTypeUnitEnum {
    Gram = 'GRAM',
    Kcal = 'KCAL',
    Kj = 'KJ',
}

export interface OfficeDay {
    readonly closingTime?: Maybe<Scalars['String']['output']>
    /** @deprecated Use 'weekday' instead. */
    readonly dayOfTheWeek: WeekDayEnum
    readonly id: Scalars['ID']['output']
    readonly openingTime?: Maybe<Scalars['String']['output']>
    readonly user: User
    readonly weekday: WeekDayEnum
}

/** Onboarding steps enum */
export enum OnboardingStepsEnum {
    /** Allergens */
    Allergens = 'ALLERGENS',
    /** Locations */
    Locations = 'LOCATIONS',
    /** None */
    None = 'None',
    /**
   * Office days
   * @deprecated office_days will be removed in the future.
   */
    OfficeDays = 'OFFICE_DAYS',
}

export interface Order {
    readonly cityName?: Maybe<Scalars['String']['output']>
    readonly createdAt: Scalars['DateTime']['output']
    readonly expiredAt?: Maybe<Scalars['DateTime']['output']>
    readonly id: Scalars['ID']['output']
    /** True when the order was created via POS and is for immediate fulfillment. */
    readonly isImmediateFulfillment: Scalars['Boolean']['output']
    readonly isOrderOnAccount: Scalars['Boolean']['output']
    readonly orderLines: ReadonlyArray<OrderLine>
    readonly paidAt?: Maybe<Scalars['DateTime']['output']>
    /** Amount paid by the customer in cents. For Innovorder orders this is the subsidized Innovorder total when available; order/line totalPrice keep the Join list prices. */
    readonly paidPrice?: Maybe<Scalars['Cent']['output']>
    readonly payment?: Maybe<Payment>
    readonly pickedUpAt?: Maybe<Scalars['DateTime']['output']>
    readonly pickedUpOrderLineIds?: Maybe<ReadonlyArray<Scalars['ID']['output']>>
    readonly postalCode?: Maybe<Scalars['String']['output']>
    readonly reservedAt: Scalars['DateTime']['output']
    readonly restaurant: Restaurant
    readonly status: OrderStatusEnum
    readonly streetName?: Maybe<Scalars['String']['output']>
    readonly streetNumber?: Maybe<Scalars['String']['output']>
    readonly totalPrice: Scalars['Cent']['output']
    readonly transferableFrom: Scalars['DateTime']['output']
    readonly transferableUntil: Scalars['DateTime']['output']
    readonly updatedAt: Scalars['DateTime']['output']
    readonly user: User
}

export interface OrderBelongsTo {
    readonly connect: Scalars['ID']['input']
}

/** Allows ordering a list of records. */
export interface OrderByClause {
    /** The column that is used for ordering. */
    readonly column: Scalars['String']['input']
    /** The direction that is used for ordering. */
    readonly order: SortOrder
}

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
    /** Amount of items. */
    Count = 'COUNT',
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
    /** Average. */
    Avg = 'AVG',
    /** Amount of items. */
    Count = 'COUNT',
    /** Maximum. */
    Max = 'MAX',
    /** Minimum. */
    Min = 'MIN',
    /** Sum. */
    Sum = 'SUM',
}

/** The input type for the creation of one single order. */
export interface OrderCreationInput {
    /**
   * Provide a delivery address when appropriate.
   * This property is required if the restaurant is
   * of type delivery. It may be omitted otherwise.
   */
    readonly deliveryAddress?: InputMaybe<DeliveryAddressInput>
    readonly orderLines: ReadonlyArray<OrderLineCreationInput>
    readonly restaurantId: Scalars['ID']['input']
    /**
   * Provide the ID of a selected timeslot when appropriate.
   * This property is required if the restaurant is configured
   * to use timeslots. It may be omitted otherwise.
   */
    readonly timeslotId?: InputMaybe<Scalars['ID']['input']>
    readonly transferDate: Scalars['Date']['input']
}

export interface OrderExportInput {
    readonly endDate: Scalars['Date']['input']
    readonly restaurantId?: InputMaybe<Scalars['ID']['input']>
    readonly startDate: Scalars['Date']['input']
}

export interface OrderFeedDay {
    readonly date: Scalars['Date']['output']
    readonly orders: ReadonlyArray<Order>
}

export interface OrderFeedFilterInput {
    readonly restaurant: Scalars['ID']['input']
}

export interface OrderFeedInput {
    readonly date: Scalars['Date']['input']
    readonly filter?: InputMaybe<OrderFeedFilterInput>
}

export interface OrderHistoryFilterConsumptionDateRangeInput {
    /** Format: yyyy-MM-dd */
    readonly endDate?: InputMaybe<Scalars['Date']['input']>
    /** Format: yyyy-MM-dd */
    readonly startDate?: InputMaybe<Scalars['Date']['input']>
}

export interface OrderHistoryFilterInput {
    readonly consumptionDateRange?: InputMaybe<OrderHistoryFilterConsumptionDateRangeInput>
    /** Defaults to false */
    readonly excludePickedUp?: InputMaybe<Scalars['Boolean']['input']>
    readonly restaurant?: InputMaybe<RestaurantBelongsTo>
}

export interface OrderHistoryInput {
    readonly filter?: InputMaybe<OrderHistoryFilterInput>
    readonly pagination: OrderHistoryPaginationInput
    readonly sorting: OrderHistorySortingEnum
}

export interface OrderHistoryPaginationInput {
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface OrderHistoryPaginator {
    readonly data: ReadonlyArray<Order>
    readonly paginatorInfo: PaginatorInfo
}

export enum OrderHistorySortingEnum {
    ConsumptionDateDesc = 'CONSUMPTION_DATE_DESC',
    PaidAtDesc = 'PAID_AT_DESC',
}

export interface OrderLine {
    readonly additions: ReadonlyArray<Addition>
    readonly currentProductVersion?: Maybe<ProductVersion>
    readonly id: Scalars['ID']['output']
    readonly productVersion: ProductVersion
    readonly totalPrice: Scalars['Cent']['output']
    readonly vatTariffPercentage?: Maybe<Scalars['Int']['output']>
}

export interface OrderLineCreationInput {
    readonly additionIds: ReadonlyArray<Scalars['ID']['input']>
    readonly menuEntryOccurrenceId: Scalars['ID']['input']
    readonly quantity: Scalars['Int']['input']
}

export interface OrderReceipt {
    readonly status: OrderReceiptStatusEnum
}

export enum OrderReceiptStatusEnum {
    Failed = 'FAILED',
    Success = 'SUCCESS',
}

export interface OrderSheet {
    /**
   * The filter applied to the full dataset. When set, the current dataset is
   * a subset of all available data. This corresponds to the raw input filter
   * and does not take into account further filtering that may have automatically
   * been performed by the authorization system.
   */
    readonly appliedFilter?: Maybe<OrderSheetFilter>
    readonly createdAt: Scalars['DateTime']['output']
    readonly explanation: Scalars['String']['output']
    readonly isoWeek: IsoWeek
    readonly weekTotals: ReadonlyArray<OrderSheetQuantity>
    readonly weekdays: ReadonlyArray<OrderSheetWeekday>
}

export interface OrderSheetFilter {
    readonly privateCategories?: Maybe<ReadonlyArray<Scalars['ID']['output']>>
    readonly restaurants?: Maybe<ReadonlyArray<Scalars['ID']['output']>>
}

export interface OrderSheetFilterInput {
    readonly privateCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export interface OrderSheetQuantity {
    readonly category: ProductCategory
    readonly quantity: Scalars['Int']['output']
}

export interface OrderSheetRestaurant {
    readonly quantities: ReadonlyArray<OrderSheetQuantity>
    readonly restaurant: Restaurant
}

export interface OrderSheetWeekday {
    readonly dayTotals: ReadonlyArray<OrderSheetQuantity>
    readonly restaurants: ReadonlyArray<OrderSheetRestaurant>
    readonly weekDate: IsoWeekDate
}

export interface OrderSheetsExportInput {
    readonly isoWeekNumber: Scalars['IsoWeekNumber']['input']
    readonly isoWeekYear: Scalars['IsoWeekYear']['input']
}

export enum OrderStateEnum {
    Failed = 'FAILED',
    Successful = 'SUCCESSFUL',
}

export enum OrderStatusEnum {
    Canceled = 'CANCELED',
    Failed = 'FAILED',
    Open = 'OPEN',
    Paid = 'PAID',
    PickedUp = 'PICKED_UP',
}

export interface OrderStatusUpdateReport {
    readonly nextStatus: OrderStatusEnum
    readonly orderID: Scalars['ID']['output']
    readonly prevStatus: OrderStatusEnum
}

export enum OrderStrategyEnum {
    Disabled = 'DISABLED',
    OrderByPayment = 'ORDER_BY_PAYMENT',
    OrderOnAccount = 'ORDER_ON_ACCOUNT',
}

export interface OrdersInput {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly endDateTime: Scalars['DateTime']['input']
    readonly locations?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly pagination: PaginationInput
    readonly paymentMethods?: InputMaybe<ReadonlyArray<PaymentMethodFilterEnum>>
    readonly restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly startDateTime: Scalars['DateTime']['input']
    readonly states?: InputMaybe<ReadonlyArray<OrderStateEnum>>
}

export interface OrdersPaginator {
    readonly data: ReadonlyArray<Order>
    readonly paginatorInfo: PaginatorInfo
}

export interface PaginationInput {
    readonly first: Scalars['Int']['input']
    readonly page: Scalars['Int']['input']
}

/** Retrieved from: https://lighthouse-php.com/5/api-reference/directives.html#basic-usage */
export interface PaginatorInfo {
    /** Number of items in the current page. */
    readonly count: Scalars['Int']['output']
    /** Index of the current page. */
    readonly currentPage: Scalars['Int']['output']
    /** Index of the first item in the current page. */
    readonly firstItem?: Maybe<Scalars['Int']['output']>
    /** Are there more pages after this one? */
    readonly hasMorePages: Scalars['Boolean']['output']
    /** Index of the last item in the current page. */
    readonly lastItem?: Maybe<Scalars['Int']['output']>
    /** Index of the last available page. */
    readonly lastPage: Scalars['Int']['output']
    /** Number of items per page. */
    readonly perPage: Scalars['Int']['output']
    /** Number of total available items. */
    readonly total: Scalars['Int']['output']
}

export interface Payload {
    readonly amount: Amount
    readonly appId: Scalars['String']['output']
    readonly description: Scalars['String']['output']
    /** Mollie signing payload shape (`Payload::toJson()`); locale and ids live under metadata. */
    readonly metadata: PayloadMetadata
    /** Same ids as in `metadata`; kept for older clients. */
    readonly orderId: Scalars['String']['output']
    /** Same ids as in `metadata`; kept for older clients. */
    readonly paymentId: Scalars['String']['output']
    readonly referenceId: Scalars['String']['output']
    readonly secretId: Scalars['String']['output']
    readonly webhookUrl: Scalars['String']['output']
}

export interface PayloadMetadata {
    readonly locale: Scalars['String']['output']
    readonly orderId: Scalars['String']['output']
    readonly paymentId: Scalars['String']['output']
}

export interface Payment {
    readonly amount: Scalars['Cent']['output']
    readonly checkoutUrl?: Maybe<Scalars['String']['output']>
    readonly currency: CurrencyEnum
    readonly feeAmount?: Maybe<Scalars['Cent']['output']>
    readonly id: Scalars['ID']['output']
    readonly method?: Maybe<PaymentMethodEnum>
    readonly molliePaymentId?: Maybe<Scalars['String']['output']>
    readonly orders: ReadonlyArray<Order>
    readonly refundedAmount: Scalars['Cent']['output']
    readonly status: PaymentStatusEnum
    readonly vouchers?: Maybe<ReadonlyArray<Voucher>>
}

export interface PaymentInitResult {
    readonly payload: Payload
    /** Canonical JSON identical to what was HMAC-signed (`Payload::toJson()`). Prefer this for the Mollie Terminal intent. */
    readonly payloadJson: Scalars['String']['output']
    readonly signature: Scalars['String']['output']
}

export interface PaymentMethod {
    readonly key: PaymentMethodEnum
    readonly value: Scalars['String']['output']
}

export enum PaymentMethodEnum {
    Applepay = 'APPLEPAY',
    /**
   * aka. ORDER_ON_ACCOUNT.
   *
   * Note: maybe it turns out to be a bad idea to actually make this part of the PaymentMethod enum.
   * It is conceptually different from the other payment methods, and is the only one that does not
   * imply the necessity for a remote PSP payment resource.
   */
    BillToClient = 'BILL_TO_CLIENT',
    CreditCard = 'CREDIT_CARD',
    Ideal = 'IDEAL',
    Innovorder = 'INNOVORDER',
    Paypal = 'PAYPAL',
    PointOfSale = 'POINT_OF_SALE',
}

export enum PaymentMethodFilterEnum {
    Applepay = 'APPLEPAY',
    /**
   * aka. For filtering of Payment methods and vouchers.
   *
   * Note: xxxxxx
   */
    BillToClient = 'BILL_TO_CLIENT',
    CreditCard = 'CREDIT_CARD',
    Ideal = 'IDEAL',
    Paypal = 'PAYPAL',
    PointOfSale = 'POINT_OF_SALE',
    Voucher = 'VOUCHER',
}

/**
 * @see \Checkout\PaymentResource\MolliePaymentResourceAdapter::getStatus for the mapping of Mollie status values to instances of this enum.
 * @see \Mollie\Api\Types\PaymentStatus for Mollie's documentation about the meaning of each status.
 */
export enum PaymentStatusEnum {
    Authorized = 'AUTHORIZED',
    Canceled = 'CANCELED',
    Expired = 'EXPIRED',
    Failed = 'FAILED',
    Open = 'OPEN',
    Paid = 'PAID',
    Pending = 'PENDING',
}

export interface PaymentsInput {
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface PaymentsPaginator {
    readonly data: ReadonlyArray<Payment>
    readonly paginatorInfo: PaginatorInfo
}

export interface PickUpOrderInput {
    readonly orderId: Scalars['ID']['input']
    /** Empty, partial and complete list of IDs allowed */
    readonly orderLineIds: ReadonlyArray<Scalars['ID']['input']>
}

export interface PlatformStatistic {
    readonly downloads?: Maybe<ReadonlyArray<PlatformStatisticDownloadItem>>
    readonly orders?: Maybe<ReadonlyArray<PlatformStatisticOrderItem>>
    readonly users?: Maybe<ReadonlyArray<PlatformStatisticUserItem>>
}

export interface PlatformStatisticDownloadItem {
    readonly platform: Scalars['String']['output']
    readonly stats: PlatformStatisticItem
}

export interface PlatformStatisticItem {
    readonly percentage: Scalars['Float']['output']
    readonly periodAverage: Scalars['Float']['output']
    readonly periodValue: Scalars['Int']['output']
    readonly totalAverage: Scalars['Float']['output']
    readonly totalValue: Scalars['Int']['output']
}

export interface PlatformStatisticOrderItem {
    readonly stats: PlatformStatisticItem
    readonly type: Scalars['String']['output']
}

export enum PlatformStatisticTypeEnum {
    ActiveUsers = 'ACTIVE_USERS',
    AppDownloadsAndroid = 'APP_DOWNLOADS_ANDROID',
    AppDownloadsIos = 'APP_DOWNLOADS_IOS',
    CanceledOrders = 'CANCELED_ORDERS',
    FailedOrders = 'FAILED_ORDERS',
    PickedUpOrders = 'PICKED_UP_ORDERS',
    SuccessfulOrders = 'SUCCESSFUL_ORDERS',
}

export interface PlatformStatisticUserItem {
    readonly stats: PlatformStatisticItem
    readonly type: Scalars['String']['output']
}

export interface PlatformStatisticsInput {
    readonly endDate: Scalars['Date']['input']
    readonly startDate: Scalars['Date']['input']
}

export interface PollExportInput {
    readonly clientId?: InputMaybe<Scalars['ID']['input']>
    readonly pollId: Scalars['ID']['input']
}

export interface PollsInput {
    readonly clientIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly endDate: Scalars['Date']['input']
    readonly pagination: PaginationInput
    readonly pollType?: InputMaybe<QuestionTypeEnum>
    readonly searchQuery?: InputMaybe<Scalars['String']['input']>
    readonly startDate: Scalars['Date']['input']
}

export interface PollsPaginator {
    readonly data: ReadonlyArray<Question>
    readonly paginatorInfo: PaginatorInfo
}

/** Input for creating a single order from POS. No timeslot required. */
export interface PosOrderCreationInput {
    readonly orderLines: ReadonlyArray<OrderLineCreationInput>
    readonly restaurantId: Scalars['ID']['input']
    /** Order date. Defaults to today when omitted. Required only when ordering for another day. */
    readonly transferDate?: InputMaybe<Scalars['Date']['input']>
}

export interface PricingAgreement {
    readonly client: Client
    readonly clientId: Scalars['ID']['output']
    readonly clientPrice?: Maybe<Scalars['Cent']['output']>
    readonly id: Scalars['ID']['output']
    readonly productCategory: ProductCategory
    readonly productCategoryId: Scalars['ID']['output']
    readonly sellingPrice?: Maybe<Scalars['Cent']['output']>
}

export interface PricingAgreementsQueryFilter {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly productCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export interface Product {
    readonly category: ProductCategory
    readonly createdAt: Scalars['DateTime']['output']
    readonly currentVersion: ProductVersion
    readonly dietaryClass?: Maybe<DietaryClassEnum>
    readonly externalRecipeId?: Maybe<Scalars['String']['output']>
    readonly id: Scalars['ID']['output']
    readonly isOnMenu: Scalars['Boolean']['output']
    readonly name: Scalars['String']['output']
    readonly publicCategory?: Maybe<PublicCategory>
    readonly source: ItemSourceEnum
    readonly tagline?: Maybe<Scalars['String']['output']>
    readonly tags: ReadonlyArray<Tag>
    readonly translations: ReadonlyArray<ProductTranslation>
    readonly type: ProductTypeEnum
    readonly updatedAt: Scalars['DateTime']['output']
    readonly vatTariffPercentage?: Maybe<Scalars['Int']['output']>
    readonly versions: ReadonlyArray<ProductVersion>
}

export interface ProductAllergenInput {
    readonly groupId: Scalars['ID']['input']
    readonly presence: AllergenPresence
    readonly specificIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export interface ProductCategoriesFilterInput {
    readonly clientId?: InputMaybe<Scalars['ID']['input']>
    readonly locationId?: InputMaybe<Scalars['ID']['input']>
    readonly restaurantId?: InputMaybe<Scalars['ID']['input']>
}

export interface ProductCategoriesInput {
    readonly filters?: InputMaybe<ProductCategoryFiltersInput>
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface ProductCategoriesPaginator {
    readonly data: ReadonlyArray<ProductCategory>
    readonly paginatorInfo: PaginatorInfo
}

export enum ProductCategoriesScopeTypeEnum {
    Client = 'CLIENT',
    Location = 'LOCATION',
    Restaurant = 'RESTAURANT',
}

export interface ProductCategory {
    readonly externalCategories: ReadonlyArray<ExternalCategory>
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
    /** @deprecated This field no longer exists in the database. */
    readonly position?: Maybe<Scalars['Int']['output']>
    readonly publicCategory?: Maybe<PublicCategory>
    readonly restaurants: ReadonlyArray<Restaurant>
}

export interface ProductCategoryBelongsTo {
    readonly connect: Scalars['ID']['input']
}

export interface ProductCategoryFiltersInput {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly hasPublicCategory?: InputMaybe<Scalars['Boolean']['input']>
    readonly locations?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly publicCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly query?: InputMaybe<Scalars['String']['input']>
    readonly restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export interface ProductCategoryPrice {
    readonly client: Client
    readonly clientPrice?: Maybe<Scalars['Cent']['output']>
    readonly id: Scalars['ID']['output']
    readonly productCategory: ProductCategory
    readonly sellingPrice?: Maybe<Scalars['Cent']['output']>
}

export interface ProductCategoryPriceInput {
    readonly clientPrice: Scalars['Cent']['input']
    readonly productCategoryId: Scalars['ID']['input']
    readonly sellingPrice: Scalars['Cent']['input']
}

export interface ProductFiltersInput {
    readonly categories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly query?: InputMaybe<Scalars['String']['input']>
    readonly types?: InputMaybe<ReadonlyArray<ProductTypeEnum>>
}

export interface ProductItem {
    readonly productId: Scalars['ID']['input']
    readonly quantity: Scalars['Int']['input']
}

export interface ProductRejectsInput {
    /** Optionally provide a list of IDs to **exclude** from the list of results */
    readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export interface ProductSalesEntry {
    readonly additions: ReadonlyArray<AdditionSalesEntry>
    readonly amountClaimed: Scalars['Int']['output']
    readonly amountIssued: Scalars['Int']['output']
    readonly amountReserved: Scalars['Int']['output']
    readonly product: Product
}

export interface ProductSalesFilters {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly states?: InputMaybe<ReadonlyArray<OrderStateEnum>>
}

export interface ProductSalesPage {
    readonly data: ReadonlyArray<ProductSalesEntry>
    readonly paginatorInfo: PaginatorInfo
}

export interface ProductSalesPerCategoryFilters {
    readonly clientId?: InputMaybe<Scalars['ID']['input']>
    readonly restaurantId?: InputMaybe<Scalars['ID']['input']>
    readonly states?: InputMaybe<ReadonlyArray<OrderStateEnum>>
}

export interface ProductSalesPerCategoryInput {
    readonly filters: ProductSalesPerCategoryFilters
    readonly from: Scalars['String']['input']
    readonly until: Scalars['String']['input']
}

export interface ProductSalesPerCategoryPayload {
    readonly productSalesPerCategory?: Maybe<ReadonlyArray<ProductSalesPerCategoryPublicCategories>>
    readonly restaurant?: Maybe<Restaurant>
}

export interface ProductSalesPerCategoryPublicCategories {
    readonly itemsSold: Scalars['Int']['output']
    readonly publicCategoryId: Scalars['Int']['output']
    readonly publicCategoryName: Scalars['String']['output']
    readonly totalRevenue: Scalars['Float']['output']
}

export interface ProductTranslation {
    readonly locale: Scalars['String']['output']
    readonly name: Scalars['String']['output']
    readonly tagline?: Maybe<Scalars['String']['output']>
}

export interface ProductTranslationInput {
    readonly locale: Scalars['String']['input']
    readonly name: Scalars['String']['input']
    readonly tagline?: InputMaybe<Scalars['String']['input']>
}

export enum ProductTypeEnum {
    Dessert = 'DESSERT',
    Drink = 'DRINK',
    Meal = 'MEAL',
    SideDish = 'SIDE_DISH',
}

export interface ProductVersion {
    readonly additions: ReadonlyArray<Addition>
    readonly allergenGroups: ReadonlyArray<AllergenGroupDeclaration>
    /** @deprecated Use allergenGroups. */
    readonly allergens: ReadonlyArray<Allergen>
    readonly createdAt: Scalars['DateTime']['output']
    readonly description?: Maybe<Scalars['String']['output']>
    /** @deprecated Will be removed in V5. */
    readonly endsAt?: Maybe<Scalars['Date']['output']>
    readonly id: Scalars['ID']['output']
    readonly image?: Maybe<ProductVersionImage>
    readonly marginPercentage: Scalars['Float']['output']
    readonly nutrients: ReadonlyArray<Nutrient>
    readonly price: Scalars['Cent']['output']
    readonly product: Product
    readonly shortDescription?: Maybe<Scalars['String']['output']>
    /** @deprecated Will be removed in V5. Use `createdAt` instead. */
    readonly startsAt: Scalars['Date']['output']
    readonly translations: ReadonlyArray<ProductVersionTranslation>
}

export interface ProductVersionBelongsTo {
    readonly connect: Scalars['ID']['input']
}

export interface ProductVersionImage {
    readonly variants: ProductVersionImages
}

export enum ProductVersionImageVariantEnum {
    Original = 'ORIGINAL',
    Square_150 = 'SQUARE_150',
    Square_300 = 'SQUARE_300',
    Square_600 = 'SQUARE_600',
}

export interface ProductVersionImages {
    readonly ORIGINAL: Scalars['String']['output']
    readonly SQUARE_150: Scalars['String']['output']
    readonly SQUARE_300: Scalars['String']['output']
    readonly SQUARE_600: Scalars['String']['output']
}

export interface ProductVersionImagesInput {
    readonly productVersionId: Scalars['ID']['input']
}

export interface ProductVersionTranslation {
    readonly description?: Maybe<Scalars['String']['output']>
    readonly locale: Scalars['String']['output']
    readonly shortDescription?: Maybe<Scalars['String']['output']>
}

export interface ProductVersionTranslationInput {
    readonly description?: InputMaybe<Scalars['String']['input']>
    readonly locale: Scalars['String']['input']
    readonly shortDescription?: InputMaybe<Scalars['String']['input']>
}

export interface ProductsInput {
    readonly filters?: InputMaybe<ProductFiltersInput>
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
    readonly rejects?: InputMaybe<ProductRejectsInput>
    readonly sorting?: InputMaybe<ReadonlyArray<SortingInput>>
}

export interface ProductsPaginator {
    readonly data: ReadonlyArray<Product>
    readonly paginatorInfo: PaginatorInfo
}

export enum ProductsSortableColumnEnum {
    UpdatedAt = 'UPDATED_AT',
}

export interface PublicCategoriesInput {
    readonly filters?: InputMaybe<PublicCategoryFiltersInput>
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface PublicCategoriesPaginator {
    readonly data: ReadonlyArray<PublicCategory>
    readonly paginatorInfo: PaginatorInfo
}

export interface PublicCategory {
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
    readonly portionDescription?: Maybe<Scalars['String']['output']>
    readonly position: Scalars['Int']['output']
    readonly productCategories: ReadonlyArray<ProductCategory>
    readonly translations: ReadonlyArray<PublicCategoryTranslation>
    readonly updatedAt: Scalars['DateTime']['output']
}

export interface PublicCategoryFiltersInput {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly locations?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly query?: InputMaybe<Scalars['String']['input']>
    readonly restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

export interface PublicCategoryTranslation {
    readonly locale: Scalars['String']['output']
    readonly name: Scalars['String']['output']
    readonly portionDescription?: Maybe<Scalars['String']['output']>
}

export interface PublicCategoryTranslationInput {
    readonly locale: Scalars['String']['input']
    readonly name: Scalars['String']['input']
    readonly portionDescription?: InputMaybe<Scalars['String']['input']>
}

export interface PurchaseOrder {
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    readonly isoWeekNumber: Scalars['IsoWeekNumber']['output']
    readonly isoWeekYear: Scalars['IsoWeekYear']['output']
    readonly purchaseOrderLines: ReadonlyArray<PurchaseOrderLine>
    readonly restaurant: Restaurant
    readonly status: PurchaseOrderStatusEnum
    readonly submittedAt?: Maybe<Scalars['DateTime']['output']>
    readonly submittedBy?: Maybe<User>
    readonly updatedAt: Scalars['DateTime']['output']
}

export interface PurchaseOrderLine {
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    /** @deprecated Can be derived from 'weekday'. This field will be removed in the future. */
    readonly isoWeekday: Scalars['IsoDayNumber']['output']
    readonly productCategory: ProductCategory
    readonly purchaseOrder: PurchaseOrder
    readonly quantity: Scalars['Int']['output']
    readonly updatedAt: Scalars['DateTime']['output']
    readonly weekday: WeekDayEnum
}

export enum PurchaseOrderStatusEnum {
    Draft = 'DRAFT',
    PastDue = 'PAST_DUE',
    Submitted = 'SUBMITTED',
}

export interface PurchaseOrdersInput {
    readonly isoWeekNumber: Scalars['IsoWeekNumber']['input']
    readonly isoWeekYear: Scalars['IsoWeekYear']['input']
    readonly restaurantIds: ReadonlyArray<Scalars['ID']['input']>
}

export interface Query {
    readonly allergen?: Maybe<Allergen>
    readonly allergens: ReadonlyArray<Allergen>
    readonly answers: ReadonlyArray<Answer>
    readonly apiVersion: ApiVersion
    readonly appCompatibility: AppCompatibilityStatus
    readonly brandRestaurants: ReadonlyArray<InnovorderRestaurant>
    readonly client: Client
    readonly clientSuggestion?: Maybe<Client>
    readonly clients: ClientPaginator
    readonly closedDate: ClosedDate
    readonly closedDates: ReadonlyArray<ClosedDate>
    readonly contentMedia: ContentMedia
    readonly contentMedias: ContentMediaPaginator
    readonly dailyGuestEstimations: ReadonlyArray<DailyGuestEstimation>
    /**
   * Get the menu for a single day. Takes the mandatory arguments 'clientID' and 'date' to filter
   * the menu by. The result set may be further filtered using the optional 'filters' argument.
   * Returns null if no data matches the given filters.
   */
    readonly dailyMenu?: Maybe<DailyMenu>
    readonly dailyMenuItem: DailyMenuItem
    /** @deprecated Use the DietaryClassEnum directly instead. */
    readonly dietaryClasses: ReadonlyArray<DietaryClass>
    /**
   * Get a list of average dish-ratings for many products at once. Only ratings for items that were
   * served between the given start- and end-dates (inclusive) add to the calculated average rating.
   */
    readonly dishRatingAverages: DishRatingAveragesPaginator
    /** Paginate a certain set of dish-ratings. */
    readonly dishRatings: DishRatingsPaginator
    /**
   * Get the total number of responses from feedback_dish_ratings table that match the given filters.
   * Note that this is different than what you get from dishRatingAverages
   */
    readonly dishRatingsAverage: Scalars['Float']['output']
    /**
   * Get the total number of responses from feedback_dish_ratings table that match the given filters.
   * Note that this is different from total results that you get from DishRatingAveragesPaginator
   */
    readonly dishRatingsCount: Scalars['Int']['output']
    readonly externalCategories: ReadonlyArray<ExternalCategory>
    readonly fileExport?: Maybe<FileExport>
    readonly fileExports?: Maybe<FileExportsPaginator>
    readonly financeDataForPayments: ReadonlyArray<FinanceDataForPayment>
    readonly financeDataForProductCategories: ReadonlyArray<FinanceDataForProductCategory>
    readonly financeDataForProductTypes: ReadonlyArray<FinanceDataForProductType>
    readonly financeDataSummary?: Maybe<ReadonlyArray<FinanceDataForSummary>>
    readonly innovorderBrand?: Maybe<InnovorderClientLink>
    readonly innovorderBrands: ReadonlyArray<InnovorderClientLink>
    readonly innovorderMe: InnovorderMe
    readonly innovorderMenuTags: ReadonlyArray<InnovorderMenuTag>
    /** The latest Kiosk and POS orders of the logged-in customer, newest first. */
    readonly innovorderPastOrders: ReadonlyArray<InnovorderPastOrder>
    readonly innovorderPaymentMethods: ReadonlyArray<InnovorderPaymentMethod>
    readonly innovorderRestaurant?: Maybe<InnovorderRestaurantLink>
    readonly innovorderRestaurants: ReadonlyArray<InnovorderRestaurantLink>
    readonly innovorderStripeConfig: InnovorderStripeConfig
    readonly internalVoucher?: Maybe<InternalVoucher>
    readonly internalVouchers?: Maybe<InternalVouchersPaginator>
    readonly isRatedByUser: Scalars['Boolean']['output']
    readonly latestAppVersions: LatestAppVersion
    /**
   * Get a list of published MenuEntryOccurrence records for the restaurant by given ID
   * on the given date. Returns null if the restaurant of given ID is closed on the
   * given date, or if a menu for the given date is not yet published.
   */
    readonly liveMenu?: Maybe<ReadonlyArray<MenuEntryOccurrence>>
    readonly locales: ReadonlyArray<Locale>
    readonly location: Location
    /**
   * Query a location by shortcode. Returns null if no location matches the given
   * shortcode or when it is not accessible by the requesting actor.
   */
    readonly locationByShortcode?: Maybe<Location>
    readonly locations: LocationsPaginator
    readonly me: User
    /** Fetches a list of menu entries for the given week parameters and (optional) filters. */
    readonly menuEntries: ReadonlyArray<MenuEntry>
    readonly menuEntry?: Maybe<MenuEntry>
    readonly menuEntryOccurrence?: Maybe<MenuEntryOccurrence>
    readonly menuEntryOccurrences: ReadonlyArray<MenuEntryOccurrence>
    /** Get the list of all existing menu-entry tags. */
    readonly menuEntryTags: ReadonlyArray<MenuEntryTag>
    /**
   * Get the internal representation of a weekly menu. This is only for administration tasks!
   * If a menu for the given week parameters does not yet exist one will be created and returned afterwards.
   */
    readonly menuInternal: Menu
    readonly narrowcastingTablet: NarrowcastingTablet
    readonly narrowcastingTabletByDisplayCode?: Maybe<NarrowcastingTablet>
    readonly narrowcastingTablets: NarrowcastingTabletsPaginator
    readonly newProductCategories: ProductCategoriesPaginator
    readonly newsItem: NewsItem
    readonly newsItems: NewsItemsPaginator
    readonly nutrientType?: Maybe<NutrientType>
    readonly nutrientTypes: ReadonlyArray<NutrientType>
    readonly oneCategory: Category
    readonly oneMenu: InnovorderMenu
    readonly oneProduct: InnovorderProduct
    readonly order: Order
    /**
   * An order overview created for kitchen-screens
   * Input requires a date and restaurant id
   */
    readonly orderFeed: OrderFeedDay
    /** @deprecated Let's work towards the situation where the orders query can fulfil these requests. It might have to implement sorting options first. */
    readonly orderHistory: OrdersPaginator
    readonly orderSheet: OrderSheet
    readonly orders: OrdersPaginator
    readonly payment: Payment
    readonly paymentMethods: ReadonlyArray<PaymentMethod>
    readonly payments: PaymentsPaginator
    readonly platformStatistics: PlatformStatistic
    readonly poll: Question
    readonly polls: PollsPaginator
    readonly previewCart: CartPreview
    readonly pricingAgreements: ReadonlyArray<PricingAgreement>
    readonly product?: Maybe<Product>
    readonly productCategories: ProductCategoriesPaginator
    readonly productCategory: ProductCategory
    readonly productCategoryPricesForCategory: ReadonlyArray<ProductCategoryPrice>
    readonly productCategoryPricesForClient: ReadonlyArray<ProductCategoryPrice>
    readonly productSales: ProductSalesPage
    readonly productSalesPerCategory: ProductSalesPerCategoryPayload
    readonly productVersionImages: ProductVersionImages
    readonly products: ProductsPaginator
    readonly publicCategories: PublicCategoriesPaginator
    readonly publicCategory: PublicCategory
    readonly purchaseOrders: ReadonlyArray<PurchaseOrder>
    readonly question: Question
    readonly questions: ReadonlyArray<Question>
    readonly rateableProducts: ReadonlyArray<RateableProduct>
    readonly requestOrderReceipt: OrderReceipt
    readonly restaurant: Restaurant
    readonly restaurantOrderStrategies: ReadonlyArray<RestaurantOrderStrategyWithModels>
    readonly restaurants: RestaurantsPaginator
    readonly roles: ReadonlyArray<Role>
    readonly storableClientTheme?: Maybe<StorableClientTheme>
    readonly tags: ReadonlyArray<Tag>
    readonly templateMenu?: Maybe<TemplateMenu>
    readonly templateMenus: ReadonlyArray<TemplateMenu>
    /** Get the timeslot template-set for the restaurant by the given restaurant-ID, if any. */
    readonly timeslotTemplateSet?: Maybe<TimeslotTemplateSet>
    readonly timeslotTemplateSets: ReadonlyArray<TimeslotTemplateSet>
    /**
   * Renders a list of timeslots for the given restaurant on the given date. Returns an empty list if
   * either the restaurant is closed or does not have an active timeslot-template set on the given date.
   */
    readonly timeslots: ReadonlyArray<Timeslot>
    /** @deprecated Use dishRatingsCount instead */
    readonly totalDishRatingAverages: Scalars['Int']['output']
    readonly user?: Maybe<User>
    readonly userIncludingDeleted?: Maybe<User>
    readonly userStatuses: ReadonlyArray<UserStatus>
    readonly users?: Maybe<UsersPaginator>
    readonly vouchers?: Maybe<ReadonlyArray<Maybe<Voucher>>>
    readonly walletBalance: WalletBalance
    readonly weekDayEnums: ReadonlyArray<WeekDayEnum>
}


export interface QueryAllergenArgs {
    id?: InputMaybe<Scalars['ID']['input']>
}


export interface QueryAnswersArgs {
    input: AnswersInput
}


export interface QueryAppCompatibilityArgs {
    appVersion: Scalars['Semver']['input']
    supportedApiRange: Scalars['SemverRange']['input']
}


export interface QueryBrandRestaurantsArgs {
    brandId: Scalars['ID']['input']
}


export interface QueryClientArgs {
    id: Scalars['ID']['input']
}


export interface QueryClientSuggestionArgs {
    email?: InputMaybe<Scalars['String']['input']>
}


export interface QueryClientsArgs {
    first?: Scalars['Int']['input']
    input: ClientsInput
    page?: InputMaybe<Scalars['Int']['input']>
}


export interface QueryClosedDateArgs {
    id: Scalars['ID']['input']
}


export interface QueryContentMediaArgs {
    id: Scalars['ID']['input']
}


export interface QueryContentMediasArgs {
    input: ContentMediasInput
}


export interface QueryDailyGuestEstimationsArgs {
    input?: InputMaybe<DailyGuestEstimationFilterInput>
}


export interface QueryDailyMenuArgs {
    clientID: Scalars['ID']['input']
    date: Scalars['Date']['input']
    filters?: InputMaybe<DailyMenuFilters>
}


export interface QueryDailyMenuItemArgs {
    clientID?: InputMaybe<Scalars['ID']['input']>
    menuEntryOccurrenceID: Scalars['ID']['input']
}


export interface QueryDishRatingAveragesArgs {
    categories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    dietaryClasses?: InputMaybe<ReadonlyArray<DietaryClassEnum>>
    endDate?: InputMaybe<Scalars['Date']['input']>
    pagination: PaginationInput
    searchQuery?: InputMaybe<Scalars['String']['input']>
    sorting: ReadonlyArray<SortingInput>
    startDate?: InputMaybe<Scalars['Date']['input']>
}


export interface QueryDishRatingsArgs {
    clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    endDate?: InputMaybe<Scalars['Date']['input']>
    pagination: PaginationInput
    products?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    startDate?: InputMaybe<Scalars['Date']['input']>
}


export interface QueryDishRatingsAverageArgs {
    input?: InputMaybe<DishRatingsStatisticsInput>
}


export interface QueryDishRatingsCountArgs {
    input?: InputMaybe<DishRatingsStatisticsInput>
}


export interface QueryFileExportArgs {
    id: Scalars['ID']['input']
}


export interface QueryFileExportsArgs {
    pagination: PaginationInput
    statuses?: InputMaybe<ReadonlyArray<FileExportStatusEnum>>
    types?: InputMaybe<ReadonlyArray<FileExportTypeEnum>>
}


export interface QueryFinanceDataForPaymentsArgs {
    filters: FinanceDataFilterInput
}


export interface QueryFinanceDataForProductCategoriesArgs {
    filters: FinanceDataFilterInput
}


export interface QueryFinanceDataForProductTypesArgs {
    filters: FinanceDataFilterInput
}


export interface QueryFinanceDataSummaryArgs {
    filters: FinanceDataFilterInput
}


export interface QueryInnovorderBrandArgs {
    clientId: Scalars['ID']['input']
}


export interface QueryInnovorderMeArgs {
    brandId: Scalars['ID']['input']
}


export interface QueryInnovorderMenuTagsArgs {
    brandId: Scalars['ID']['input']
    menuId: Scalars['ID']['input']
}


export interface QueryInnovorderPastOrdersArgs {
    brandId?: InputMaybe<Scalars['ID']['input']>
}


export interface QueryInnovorderPaymentMethodsArgs {
    brandId?: InputMaybe<Scalars['ID']['input']>
    date?: InputMaybe<Scalars['Date']['input']>
    restaurantId: Scalars['ID']['input']
}


export interface QueryInnovorderRestaurantArgs {
    restaurantId: Scalars['ID']['input']
}


export interface QueryInnovorderRestaurantsArgs {
    brandId?: InputMaybe<Scalars['ID']['input']>
}


export interface QueryInnovorderStripeConfigArgs {
    brandId?: InputMaybe<Scalars['ID']['input']>
    restaurantId: Scalars['ID']['input']
}


export interface QueryInternalVoucherArgs {
    id: Scalars['ID']['input']
}


export interface QueryInternalVouchersArgs {
    input: InternalVouchersInput
}


export interface QueryIsRatedByUserArgs {
    input: IsRatedByUserInput
}


export interface QueryLiveMenuArgs {
    date: Scalars['Date']['input']
    restaurantID: Scalars['ID']['input']
}


export interface QueryLocationArgs {
    id: Scalars['ID']['input']
}


export interface QueryLocationByShortcodeArgs {
    shortcode: Scalars['String']['input']
}


export interface QueryLocationsArgs {
    input: LocationsInput
}


export interface QueryMenuEntriesArgs {
    filter?: InputMaybe<MenuEntriesQueryFilter>
    isoWeekNumber: Scalars['IsoWeekNumber']['input']
    isoWeekYear: Scalars['IsoWeekYear']['input']
}


export interface QueryMenuEntryArgs {
    id: Scalars['ID']['input']
}


export interface QueryMenuEntryOccurrenceArgs {
    id: Scalars['ID']['input']
}


export interface QueryMenuEntryOccurrencesArgs {
    filter?: InputMaybe<MenuEntryOccurrencesQueryFilter>
    isoWeekNumber: Scalars['IsoWeekNumber']['input']
    isoWeekYear: Scalars['IsoWeekYear']['input']
}


export interface QueryMenuInternalArgs {
    isoWeekNumber: Scalars['IsoWeekNumber']['input']
    isoWeekYear: Scalars['IsoWeekYear']['input']
}


export interface QueryNarrowcastingTabletArgs {
    id: Scalars['ID']['input']
}


export interface QueryNarrowcastingTabletByDisplayCodeArgs {
    displayCode: Scalars['String']['input']
}


export interface QueryNarrowcastingTabletsArgs {
    input: NarrowcastingTabletsInput
}


export interface QueryNewProductCategoriesArgs {
    input: ProductCategoriesInput
}


export interface QueryNewsItemArgs {
    id: Scalars['ID']['input']
}


export interface QueryNewsItemsArgs {
    input: NewsItemsInput
}


export interface QueryNutrientTypeArgs {
    id: Scalars['ID']['input']
}


export interface QueryOneCategoryArgs {
    brandId: Scalars['ID']['input']
    categoryId: Scalars['ID']['input']
    menuId: Scalars['ID']['input']
}


export interface QueryOneMenuArgs {
    brandId: Scalars['ID']['input']
    menuId: Scalars['ID']['input']
}


export interface QueryOneProductArgs {
    brandId: Scalars['ID']['input']
    menuId: Scalars['ID']['input']
    productId: Scalars['ID']['input']
}


export interface QueryOrderArgs {
    id: Scalars['ID']['input']
}


export interface QueryOrderFeedArgs {
    input?: InputMaybe<OrderFeedInput>
}


export interface QueryOrderHistoryArgs {
    input: OrderHistoryInput
}


export interface QueryOrderSheetArgs {
    filter?: InputMaybe<OrderSheetFilterInput>
    isoWeek: IsoWeekInput
}


export interface QueryOrdersArgs {
    input: OrdersInput
}


export interface QueryPaymentArgs {
    id: Scalars['ID']['input']
}


export interface QueryPaymentsArgs {
    input: PaymentsInput
}


export interface QueryPlatformStatisticsArgs {
    input?: InputMaybe<PlatformStatisticsInput>
}


export interface QueryPollArgs {
    id: Scalars['ID']['input']
}


export interface QueryPollsArgs {
    input: PollsInput
}


export interface QueryPreviewCartArgs {
    brandId?: InputMaybe<Scalars['ID']['input']>
    cart: ReadonlyArray<InnovorderOrderItemInput>
    customerId?: InputMaybe<Scalars['ID']['input']>
    date?: InputMaybe<Scalars['Date']['input']>
    restaurantId: Scalars['ID']['input']
}


export interface QueryPricingAgreementsArgs {
    filter?: InputMaybe<PricingAgreementsQueryFilter>
}


export interface QueryProductArgs {
    id: Scalars['ID']['input']
}


export interface QueryProductCategoriesArgs {
    input: ProductCategoriesInput
}


export interface QueryProductCategoryArgs {
    id: Scalars['ID']['input']
}


export interface QueryProductCategoryPricesForCategoryArgs {
    categoryId: Scalars['ID']['input']
}


export interface QueryProductCategoryPricesForClientArgs {
    clientId: Scalars['ID']['input']
}


export interface QueryProductSalesArgs {
    consumedFrom: Scalars['DateTime']['input']
    consumedUntil: Scalars['DateTime']['input']
    filters?: InputMaybe<ProductSalesFilters>
    pagination: PaginationInput
}


export interface QueryProductSalesPerCategoryArgs {
    input: ProductSalesPerCategoryInput
}


export interface QueryProductVersionImagesArgs {
    input: ProductVersionImagesInput
}


export interface QueryProductsArgs {
    input: ProductsInput
}


export interface QueryPublicCategoriesArgs {
    input: PublicCategoriesInput
}


export interface QueryPublicCategoryArgs {
    id: Scalars['ID']['input']
}


export interface QueryPurchaseOrdersArgs {
    input: PurchaseOrdersInput
}


export interface QueryQuestionArgs {
    id: Scalars['ID']['input']
}


export interface QueryQuestionsArgs {
    input: QuestionsInput
}


export interface QueryRequestOrderReceiptArgs {
    id: Scalars['ID']['input']
}


export interface QueryRestaurantArgs {
    id: Scalars['ID']['input']
}


export interface QueryRestaurantOrderStrategiesArgs {
    restaurantId: Scalars['ID']['input']
}


export interface QueryRestaurantsArgs {
    input: RestaurantsInput
}


export interface QueryStorableClientThemeArgs {
    clientId: Scalars['ID']['input']
}


export interface QueryTemplateMenuArgs {
    restaurantId: Scalars['ID']['input']
}


export interface QueryTimeslotTemplateSetArgs {
    restaurantId: Scalars['ID']['input']
}


export interface QueryTimeslotTemplateSetsArgs {
    filter?: InputMaybe<TimeslotTemplateSetsFilter>
}


export interface QueryTimeslotsArgs {
    input: TimeslotsInput
}


export interface QueryTotalDishRatingAveragesArgs {
    categories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    dietaryClasses?: InputMaybe<ReadonlyArray<DietaryClassEnum>>
    endDate?: InputMaybe<Scalars['Date']['input']>
    searchQuery?: InputMaybe<Scalars['String']['input']>
    startDate?: InputMaybe<Scalars['Date']['input']>
}


export interface QueryUserArgs {
    id?: InputMaybe<Scalars['ID']['input']>
}


export interface QueryUserIncludingDeletedArgs {
    id: Scalars['ID']['input']
}


export interface QueryUsersArgs {
    input?: InputMaybe<UsersFilterInput>
}


export interface QueryVouchersArgs {
    email: Scalars['String']['input']
}


export interface QueryWalletBalanceArgs {
    brandId?: InputMaybe<Scalars['ID']['input']>
    clientId?: InputMaybe<Scalars['ID']['input']>
    customerId?: InputMaybe<Scalars['ID']['input']>
}

export interface Question {
    readonly clients: ReadonlyArray<Client>
    readonly createdAt: Scalars['DateTime']['output']
    readonly endDate: Scalars['Date']['output']
    readonly feedback?: Maybe<Scalars['String']['output']>
    readonly id: Scalars['ID']['output']
    readonly placeholder?: Maybe<Scalars['String']['output']>
    readonly question: Scalars['String']['output']
    readonly startDate: Scalars['Date']['output']
    readonly translations: ReadonlyArray<QuestionTranslation>
    readonly type: QuestionTypeEnum
    readonly updatedAt: Scalars['DateTime']['output']
}

export interface QuestionClientInput {
    readonly id: Scalars['ID']['input']
    readonly sendNotification: Scalars['Boolean']['input']
    readonly showOnFeed: Scalars['Boolean']['input']
}

export interface QuestionTranslation {
    readonly feedback?: Maybe<Scalars['String']['output']>
    readonly locale: Scalars['String']['output']
    readonly placeholder?: Maybe<Scalars['String']['output']>
    readonly question: Scalars['String']['output']
}

export interface QuestionTranslationInput {
    readonly feedback?: InputMaybe<Scalars['String']['input']>
    readonly locale: Scalars['String']['input']
    readonly placeholder?: InputMaybe<Scalars['String']['input']>
    readonly question: Scalars['String']['input']
}

export enum QuestionTypeEnum {
    MultipleChoice = 'MULTIPLE_CHOICE',
    OpenEnded = 'OPEN_ENDED',
    Smiley = 'SMILEY',
    Star = 'STAR',
}

export interface QuestionsInput {
    readonly date: Scalars['Date']['input']
}

export interface RateableProduct {
    readonly consumptionDate: Scalars['Date']['output']
    readonly order: Order
    readonly product: Product
    readonly restaurant: Restaurant
}

/** Rating contexts enum */
export enum RatingContextsEnum {
    /** Dish detail ratings */
    DishDetailRatings = 'DISH_DETAIL_RATINGS',
    /** None */
    None = 'None',
    /** Ordered dish ratings */
    OrderedDishRatings = 'ORDERED_DISH_RATINGS',
}

export interface RefreshTokenInput {
    readonly refresh_token?: InputMaybe<Scalars['String']['input']>
}

export interface RefreshTokenPayload {
    readonly access_token: Scalars['String']['output']
    readonly expires_in: Scalars['Int']['output']
    readonly refresh_token: Scalars['String']['output']
    readonly token_type: Scalars['String']['output']
}

export interface RegisterInput {
    readonly email: Scalars['String']['input']
    readonly firstName: Scalars['String']['input']
    readonly lastName: Scalars['String']['input']
    readonly password: Scalars['String']['input']
    readonly password_confirmation: Scalars['String']['input']
    readonly preferredLanguage?: InputMaybe<Scalars['String']['input']>
}

export interface RegisterResponse {
    readonly status: RegisterStatuses
    readonly tokens?: Maybe<AuthPayload>
}

export enum RegisterStatuses {
    MustVerifyEmail = 'MUST_VERIFY_EMAIL',
    Success = 'SUCCESS',
}

/**
 * The url used to reset the password.
 * Use the `__EMAIL__` and `__TOKEN__` placeholders to inject the reset password email and token.
 *
 * e.g; `https://my-front-end.com?reset-password?email=__EMAIL__&token=__TOKEN__`
 */
export interface ResetPasswordUrlInput {
    readonly url: Scalars['String']['input']
}

export enum ResponseErrorTypeEnum {
    InsufficientStock = 'INSUFFICIENT_STOCK',
    InvalidVoucherCode = 'INVALID_VOUCHER_CODE',
    ModelResolveException = 'MODEL_RESOLVE_EXCEPTION',
    OrderDeadlineExpired = 'ORDER_DEADLINE_EXPIRED',
    PaymentCreation = 'PAYMENT_CREATION',
    ValidationError = 'VALIDATION_ERROR',
}

export interface Restaurant {
    readonly allowPickUpAtTheOffice: Scalars['Boolean']['output']
    readonly ambianceImage: AmbianceImages
    readonly categories: ReadonlyArray<ProductCategory>
    readonly clients: ReadonlyArray<Client>
    readonly createdAt: Scalars['DateTime']['output']
    readonly dishBackgroundImage?: Maybe<DishBackgroundImages>
    /** @deprecated The value of this field depends on the date for which the question is asked. It will be removed in the next major release. */
    readonly hasTimeslots: Scalars['Boolean']['output']
    readonly id: Scalars['ID']['output']
    readonly isQrCodePickup: Scalars['Boolean']['output']
    readonly location?: Maybe<Location>
    readonly name: Scalars['String']['output']
    /** @deprecated This field leaks the implementation detail that opening- and closing-times may be null. The null cases are irrelevant to restaurants and should be omitted. Use openingHours instead. */
    readonly officeDays: ReadonlyArray<OfficeDay>
    readonly orderDeadlineMarginMinutes: Scalars['Int']['output']
    readonly orderStrategies: ReadonlyArray<RestaurantOrderStrategy>
    readonly pickupInstructions?: Maybe<Scalars['String']['output']>
    readonly purchaseEnabled: Scalars['Boolean']['output']
    readonly serviceReferenceID?: Maybe<Scalars['String']['output']>
    readonly translations: ReadonlyArray<RestaurantTranslation>
    readonly type: RestaurantTypeEnum
    readonly updatedAt: Scalars['DateTime']['output']
    readonly weeklyOpeningHours: WeeklyOpeningHours
}

export enum RestaurantAmbianceImageVariantEnum {
    Original = 'ORIGINAL',
    Rectangle_615 = 'RECTANGLE_615',
}

export interface RestaurantBelongsTo {
    readonly connect: Scalars['ID']['input']
}

export interface RestaurantClientAssociationInput {
    readonly clientId: Scalars['ID']['input']
    readonly orderStrategy: OrderStrategyEnum
    readonly orderStrategyNote?: InputMaybe<Scalars['String']['input']>
}

export interface RestaurantOpeningHoursInput {
    readonly closesAt: Scalars['String']['input']
    readonly opensAt: Scalars['String']['input']
    readonly weekday: WeekDayEnum
}

export interface RestaurantOrderStrategy {
    readonly clientID: Scalars['ID']['output']
    readonly note?: Maybe<Scalars['String']['output']>
    readonly restaurantID: Scalars['ID']['output']
    readonly value: OrderStrategyEnum
}

export interface RestaurantOrderStrategyWithModels {
    readonly client: Client
    readonly note?: Maybe<Scalars['String']['output']>
    readonly restaurant: Restaurant
    readonly value: OrderStrategyEnum
}

export interface RestaurantTranslation {
    readonly locale: Scalars['String']['output']
    readonly pickupInstructions?: Maybe<Scalars['String']['output']>
}

export interface RestaurantTranslationInput {
    readonly locale: Scalars['String']['input']
    readonly pickupInstructions?: InputMaybe<Scalars['String']['input']>
}

export enum RestaurantTypeEnum {
    /** @deprecated : Remove when app/backoffice supports it */
    Delivery = 'DELIVERY',
    OrderOnDemand = 'ORDER_ON_DEMAND',
    Restaurant = 'RESTAURANT',
}

/** Lists all the associations and their auxiliary pivot data of Client with a particular Restaurant. */
export interface RestaurantWithClientAssociations {
    readonly associations: ReadonlyArray<ClientRestaurantAssociation>
    readonly restaurant: Restaurant
}

export interface RestaurantWithProductCategories {
    readonly productCategories: ReadonlyArray<ProductCategory>
    readonly restaurant: Restaurant
}

export interface RestaurantsFilterInput {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly locations?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly query?: InputMaybe<Scalars['String']['input']>
    readonly serviceReferenceId?: InputMaybe<Scalars['String']['input']>
}

export interface RestaurantsInput {
    readonly filters?: InputMaybe<RestaurantsFilterInput>
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface RestaurantsPaginator {
    readonly data: ReadonlyArray<Restaurant>
    readonly paginatorInfo: PaginatorInfo
}

export interface Role {
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    readonly name: RoleNameEnum
    readonly updatedAt: Scalars['DateTime']['output']
}

export interface RoleInput {
    readonly name: RoleNameEnum
}

export enum RoleNameEnum {
    Admin = 'ADMIN',
    ContentCreator = 'CONTENT_CREATOR',
    Curator = 'CURATOR',
    Employee = 'EMPLOYEE',
    FinanceManager = 'FINANCE_MANAGER',
    LocationManager = 'LOCATION_MANAGER',
    RegionalManager = 'REGIONAL_MANAGER',
    StaffOnLocation = 'STAFF_ON_LOCATION',
    WebApplication = 'WEB_APPLICATION',
}

export interface SavePurchaseOrderInput {
    readonly isoWeekNumber: Scalars['IsoWeekNumber']['input']
    readonly isoWeekYear: Scalars['IsoWeekYear']['input']
    readonly purchaseOrderLines: ReadonlyArray<SavePurchaseOrderLineInput>
    readonly restaurantId: Scalars['ID']['input']
    readonly submitted?: InputMaybe<Scalars['Boolean']['input']>
}

export interface SavePurchaseOrderLineInput {
    readonly isoWeekday: Scalars['IsoDayNumber']['input']
    readonly productCategoryId: Scalars['ID']['input']
    readonly quantity: Scalars['Int']['input']
}

export interface SendResetPasswordEmailInput {
    readonly userId: Scalars['ID']['input']
}

export interface ShortcodeRegisterInput {
    readonly email: Scalars['String']['input']
    readonly firstName: Scalars['String']['input']
    readonly lastName: Scalars['String']['input']
    readonly password: Scalars['String']['input']
    readonly password_confirmation: Scalars['String']['input']
    readonly preferredLanguage?: InputMaybe<Scalars['String']['input']>
    /**
   * Whether the code belongs to a client is checked by the resolver, behind the rate limiter,
   * because Lighthouse runs validation rules before any resolver middleware.
   */
    readonly registrationShortcode: Scalars['String']['input']
}

/** Directions for ordering a list of records. */
export enum SortOrder {
    /** Sort records in ascending order. */
    Asc = 'ASC',
    /** Sort records in descending order. */
    Desc = 'DESC',
}

export enum SortingDirectionEnum {
    Ascending = 'ASCENDING',
    Descending = 'DESCENDING',
}

export interface SortingInput {
    readonly direction: SortingDirectionEnum
    readonly key: Scalars['String']['input']
}

export enum StockMutationTypeEnum {
    /**
   *
   *     The CLAIM mutation increases a stock's amountClaimed by a given number, which will also increment its derived value
   *     amountReserved and decrement its derived value amountAvailable by the same number.
   *
   */
    Claim = 'CLAIM',
    /**
   *
   *     The DECREASE_TOTAL mutation decrements a stock's amount total correction by a given number,
   *     which will also decrement the following derived values by the same number:
   *     - amount total
   *     - amount available
   *     - amount issuable
   *
   */
    DecreaseTotal = 'DECREASE_TOTAL',
    /**
   *
   *     The INCREASE_TOTAL mutation increments a stock's amount total by a given number,
   *     which will also increment the following derived values by the same number:
   *     - amount total
   *     - amount available
   *     - amount issuable
   *
   */
    IncreaseTotal = 'INCREASE_TOTAL',
    /**
   *
   *     The ISSUE mutation increases a stock's amountIssued by a given number, which will also _decrement_ its derived values
   *     amountReserved and amountIssuable by the same number.
   *
   */
    Issue = 'ISSUE',
    /**
   *
   *     The ISSUE_AVAILABLE mutation increases a stock's amountIssued AND amountClaimed by a given number, which will also
   *     decrement its derived values amountAvailable and amountIssuable by the same number.
   *
   *     Note: This is the same as first claiming and then issuing stock by the given number, used by kitchen screens to issue
   *     freely available stock in one go.
   *
   */
    IssueAvailable = 'ISSUE_AVAILABLE',
    /**
   *
   *     The SET_TOTAL_INITIAL mutation sets a stock's `amountTotalInitial` to a given number.
   *     This mutation can only be used on currently unconstrained stocks, i.e. `amountTotalInitial === null`.
   *     The given value must be greater than or equal to the `amountClaimed`.
   *
   */
    SetTotalInitial = 'SET_TOTAL_INITIAL',
    /**
   *
   *     The UN_CLAIM mutation decrements a stock's amountClaimed by a given number, which will also decrement its derived
   *     value amountReserved and increment its derived value amountAvailable by the same number.
   *
   */
    UnClaim = 'UN_CLAIM',
    /**
   *
   *     The UN_CLAIM_ISSUED mutation decrements a stock's amountIssued AND amountClaimed by a given number, which will also
   *     increment its derived values amountAvailable and amountIssuable by the same number.
   *
   *     ---
   *
   *     Note: This is the same as first un-issuing and then un-claiming stock by the given number, which can be imagined as
   *     somebody who returns a previously issued dish, re-adding it to the available stock.
   *
   */
    UnClaimIssued = 'UN_CLAIM_ISSUED',
    /**
   *
   *     The UN_ISSUE mutation decreases a stock's amountIssued by a given number, which will also _increment_ its derived
   *     values amountReserved and amountIssuable by the same number.
   *
   */
    UnIssue = 'UN_ISSUE',
}

/**
 * A set of numbers that communicate the status of stock for a particular menu-item. This object
 * consists of 4 canonical values and 4 derived values. Additionally has some boolean flags that
 * provide assertion shortcuts for the contained numbers.
 */
export interface StockNumbers {
    /**
   * The amount of stock that is available for new orders and free issuing by kitchen staff.
   * This value will be null when no total constraint is actively enforced.
   */
    readonly amountAvailable?: Maybe<Scalars['Int']['output']>
    /**
   * (canonical) The amount of stock that has been claimed, i.e. (pre-)ordered. An item can be
   * claimed either by consumers through pre-orders in the app, or by kitchen staff who issue
   * free stock to ad-hoc consumers.
   */
    readonly amountClaimed: Scalars['Int']['output']
    /**
   * The portion of the amount total that has not yet been issued.
   * This value will be null when no total constraint is actively enforced.
   */
    readonly amountIssuable?: Maybe<Scalars['Int']['output']>
    /**
   * (canonical) The amount of stock that has been issued to consumers. All items that are issued must have
   * been claimed before, i.e. for each item issued, the amount claimed must have been incremented
   * by 1 previously, or at the time of issuing.
   */
    readonly amountIssued: Scalars['Int']['output']
    /** The amount of stock that has been claimed but not yet issued. */
    readonly amountReserved: Scalars['Int']['output']
    /**
   * This is the corrected total amount of stock that is available for an item.
   * This value will be null when no total constraint is actively enforced.
   */
    readonly amountTotal?: Maybe<Scalars['Int']['output']>
    /**
   * (canonical) The manual correction on the amountTotalInitial. This is the only number that
   * can be less than zero, implying a lower available stock than the (immutable) amountTotalInitial
   * implies. It can never be less than the negative mirror of amountTotalInitial,
   * e.g. if amountTotalInitial = 100, amountTotalCorrection >= -100.
   */
    readonly amountTotalCorrection: Scalars['Int']['output']
    /**
   * (canonical) This is the initial total amount of stock that is available for an item.
   * When his value is null it means that no total constraint is actively enforced.
   */
    readonly amountTotalInitial?: Maybe<Scalars['Int']['output']>
    /**
   * If true, the stock is actively constrained to a maximum and all nullable numbers in
   * this object will have an integer value. If false, all nullable numbers will be NULL.
   * Shortcut for `amountTotalInitial !== null`.
   */
    readonly isConstrained: Scalars['Boolean']['output']
    /**
   * Indicates if the total stock has been adjusted manually by kitchen staff, and therefore
   * the stockTotalInitial should be considered outdated. Adjustments can only have been made
   * on constrained stocks.
   * Shortcut for `amountTotalInitial !== null && stockTotalCorrection !== 0`.
   */
    readonly isCorrected: Scalars['Boolean']['output']
    /**
   * Indicates if the stock is fully used.
   * Shortcut for `amountTotalInitial !== null && amountAvailable === 0`.
   */
    readonly isExhausted: Scalars['Boolean']['output']
}

export interface StorableClientTheme {
    readonly colorDark: Scalars['String']['output']
    readonly colorDarkContrast?: Maybe<Scalars['String']['output']>
    readonly colorPrimary: Scalars['String']['output']
    readonly colorPrimaryContrast?: Maybe<Scalars['String']['output']>
    readonly colorSecondary: Scalars['String']['output']
    readonly colorSecondaryContrast?: Maybe<Scalars['String']['output']>
    readonly colorTertiary: Scalars['String']['output']
    readonly colorTertiaryContrast?: Maybe<Scalars['String']['output']>
    readonly isActiveForApp: Scalars['Boolean']['output']
    readonly isActiveForWeb: Scalars['Boolean']['output']
}

export interface Tag {
    readonly id: Scalars['ID']['output']
    readonly name: Scalars['String']['output']
    readonly products: ReadonlyArray<Product>
    readonly translations: ReadonlyArray<TagTranslation>
}

export enum TagStrategyEnum {
    Merge = 'MERGE',
    Remove = 'REMOVE',
    Replace = 'REPLACE',
}

export interface TagTranslation {
    readonly locale: Scalars['String']['output']
    readonly name: Scalars['String']['output']
}

export interface TagTranslationInput {
    readonly locale: Scalars['String']['input']
    readonly name: Scalars['String']['input']
}

export interface TemplateMenu {
    readonly activeFrom?: Maybe<Scalars['DateTime']['output']>
    readonly activeUntil?: Maybe<Scalars['DateTime']['output']>
    readonly entries: ReadonlyArray<TemplateMenuEntry>
    readonly id: Scalars['ID']['output']
    readonly restaurant: Restaurant
    readonly restaurantId: Scalars['ID']['output']
}

export interface TemplateMenuEntry {
    readonly defaultStock?: Maybe<Scalars['Int']['output']>
    readonly id: Scalars['ID']['output']
    readonly position: Scalars['Int']['output']
    readonly prices: ReadonlyArray<TemplateMenuEntryPrice>
    readonly product: Product
    readonly recurrence: ReadonlyArray<Scalars['IsoDayNumber']['output']>
    readonly templateMenu: TemplateMenu
    readonly templateMenuId: Scalars['ID']['output']
}

export interface TemplateMenuEntryCreationInput {
    /**
   * Optionally provide the default stock to write to future menus.
   * When not set, the stock will be considered unlimited.
   */
    readonly defaultStock?: InputMaybe<Scalars['Int']['input']>
    readonly productId: Scalars['ID']['input']
    /**
   * Provide a list of ISO day-numbers for the days on which this entry should recur
   * on future menus. Empty lists may be passed for provisional entries whose recurrences
   * will be provided later on.
   */
    readonly recurrence: ReadonlyArray<Scalars['IsoDayNumber']['input']>
    readonly restaurantId: Scalars['ID']['input']
}

export interface TemplateMenuEntryPositionInput {
    readonly position: Scalars['Int']['input']
    readonly templateMenuEntryId: Scalars['ID']['input']
}

export interface TemplateMenuEntryPrice {
    readonly client: Client
    readonly clientId: Scalars['ID']['output']
    readonly entry: TemplateMenuEntry
    readonly id: Scalars['ID']['output']
    readonly sellingPrice: Scalars['Cent']['output']
    readonly templateMenuEntryId: Scalars['ID']['output']
}

/**
 * Input for a client-specific price for a containing template-menu-entry.
 * When the sellingPrice property is null any existing record matching
 * the client and containing template-menu-entry will be removed from storage.
 */
export interface TemplateMenuEntryPriceInput {
    readonly clientId: Scalars['ID']['input']
    readonly sellingPrice?: InputMaybe<Scalars['Cent']['input']>
}

export interface TemplateMenuEntryUpdateInput {
    /**
   * Optionally provide the daily stock to write to future menus.
   * When not set, the stock will be considered unlimited.
   * If the currently saved value should remain unchanged, pass the current value in this field.
   */
    readonly defaultStock?: InputMaybe<Scalars['Int']['input']>
    readonly id: Scalars['ID']['input']
    /**
   * Provide the prices for each client served by the restaurant that this entry is for. While
   * a price is omitted for a particular client, users of that client will not see the item in
   * their app feed.
   */
    readonly prices: ReadonlyArray<TemplateMenuEntryPriceInput>
    /**
   * Provide a list of ISO day-numbers for the days on which this entry should recur on future menus.
   * Empty lists may be passed for provisional entries whose recurrences will be provided later on.
   * If the currently saved value should remain unchanged, pass it in this field.
   */
    readonly recurrence: ReadonlyArray<Scalars['IsoDayNumber']['input']>
}

export interface Timeslot {
    readonly capacityClaimed: Scalars['Int']['output']
    readonly capacityTotal?: Maybe<Scalars['Int']['output']>
    readonly endsAt: Scalars['String']['output']
    readonly id: Scalars['ID']['output']
    readonly isAvailable: Scalars['Boolean']['output']
    readonly restaurant: Restaurant
    readonly startsAt: Scalars['String']['output']
}

export interface TimeslotBelongsTo {
    readonly connect: Scalars['ID']['input']
}

export interface TimeslotTemplate {
    readonly capacity?: Maybe<Scalars['Int']['output']>
    readonly createdAt: Scalars['DateTime']['output']
    readonly endsAt: Scalars['TimeString']['output']
    readonly id: Scalars['ID']['output']
    readonly startsAt: Scalars['TimeString']['output']
    readonly timeslotTemplateSet?: Maybe<TimeslotTemplateSet>
    readonly updatedAt: Scalars['DateTime']['output']
    readonly weekday: WeekDayEnum
}

export interface TimeslotTemplateInput {
    readonly capacity?: InputMaybe<Scalars['Int']['input']>
    readonly endsAt: Scalars['TimeString']['input']
    readonly startsAt: Scalars['TimeString']['input']
    readonly weekday: WeekDayEnum
}

export interface TimeslotTemplateSet {
    readonly activeFrom: Scalars['DateTime']['output']
    readonly activeUntil?: Maybe<Scalars['DateTime']['output']>
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    readonly restaurant: Restaurant
    readonly timeslotTemplates: ReadonlyArray<TimeslotTemplate>
    readonly updatedAt: Scalars['DateTime']['output']
}

export interface TimeslotTemplateSetInput {
    readonly activeFrom: Scalars['Date']['input']
    readonly activeUntil?: InputMaybe<Scalars['Date']['input']>
    readonly timeslotTemplates: ReadonlyArray<TimeslotTemplateInput>
}

export interface TimeslotTemplateSetsFilter {
    readonly restaurants?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
    /** Only return trashed results. */
    Only = 'ONLY',
    /** Return both trashed and non-trashed results. */
    With = 'WITH',
    /** Only return non-trashed results. */
    Without = 'WITHOUT',
}

export interface TwoFactorAuthenticationConfirmInput {
    readonly code: Scalars['String']['input']
    readonly password?: InputMaybe<Scalars['String']['input']>
    readonly username?: InputMaybe<Scalars['String']['input']>
}

export interface TwoFactorAuthenticationEnableInput {
    readonly password?: InputMaybe<Scalars['String']['input']>
    readonly username?: InputMaybe<Scalars['String']['input']>
}

export interface TwoFactorSecret {
    readonly decrypted: Scalars['String']['output']
    readonly qr: Scalars['String']['output']
}

export interface UpdateAllergenInput {
    readonly icon?: InputMaybe<DeletableFileInput>
    readonly id: Scalars['ID']['input']
    readonly translations: ReadonlyArray<AllergenTranslationInput>
}

export interface UpdateClientInput {
    readonly deactivatedAt?: InputMaybe<Scalars['Date']['input']>
    readonly emailQuestionsTo: Scalars['String']['input']
    readonly id: Scalars['ID']['input']
    readonly isDemo?: InputMaybe<Scalars['Boolean']['input']>
    readonly logo?: InputMaybe<DeletableFileInput>
    readonly name: Scalars['String']['input']
    readonly onboardingSteps: ReadonlyArray<OnboardingStepsEnum>
    readonly ratingContexts: ReadonlyArray<RatingContextsEnum>
}

export interface UpdateClientThemeInput {
    readonly colorDark: Scalars['String']['input']
    readonly colorDarkContrast?: InputMaybe<Scalars['String']['input']>
    readonly colorPrimary: Scalars['String']['input']
    readonly colorPrimaryContrast?: InputMaybe<Scalars['String']['input']>
    readonly colorSecondary: Scalars['String']['input']
    readonly colorSecondaryContrast?: InputMaybe<Scalars['String']['input']>
    readonly colorTertiary: Scalars['String']['input']
    readonly colorTertiaryContrast?: InputMaybe<Scalars['String']['input']>
    readonly isActiveForApp?: InputMaybe<Scalars['Boolean']['input']>
    readonly isActiveForWeb?: InputMaybe<Scalars['Boolean']['input']>
}

export interface UpdateClosedDateInput {
    readonly content?: InputMaybe<Scalars['String']['input']>
    readonly endDate?: InputMaybe<Scalars['Date']['input']>
    readonly icon: ClosedDateIconEnum
    readonly id: Scalars['ID']['input']
    readonly startingDate?: InputMaybe<Scalars['Date']['input']>
    readonly title?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateContentMediaResponse {
    readonly contentMedia?: Maybe<ContentMedia>
    readonly deleted: Scalars['Boolean']['output']
}

export interface UpdateDailyGuestEstimationInput {
    readonly estimation: Scalars['Int']['input']
    readonly id: Scalars['ID']['input']
}

export interface UpdateInternalVoucherInput {
    readonly activeFrom: Scalars['DateTime']['input']
    readonly activeUntil: Scalars['DateTime']['input']
    readonly id: Scalars['ID']['input']
    readonly initialAmount: Scalars['Cent']['input']
    readonly userId: Scalars['ID']['input']
}

export interface UpdateLocationInput {
    readonly cityName: Scalars['String']['input']
    readonly costCenter?: InputMaybe<Scalars['String']['input']>
    readonly locationId: Scalars['ID']['input']
    readonly name: Scalars['String']['input']
    readonly postalCode: Scalars['String']['input']
    readonly streetName: Scalars['String']['input']
    readonly streetNumber: Scalars['String']['input']
}

export interface UpdateMeInput {
    readonly avatar?: InputMaybe<DeletableFileInput>
    readonly cityName?: InputMaybe<Scalars['String']['input']>
    readonly firstName?: InputMaybe<Scalars['String']['input']>
    readonly lastName?: InputMaybe<Scalars['String']['input']>
    readonly location?: InputMaybe<Scalars['ID']['input']>
    readonly newsReadAt?: InputMaybe<Scalars['DateTime']['input']>
    readonly onboardingCompletedAt?: InputMaybe<Scalars['DateTime']['input']>
    readonly postalCode?: InputMaybe<Scalars['String']['input']>
    readonly preferredLanguage?: InputMaybe<Scalars['String']['input']>
    readonly privacyPolicyAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>
    readonly streetName?: InputMaybe<Scalars['String']['input']>
    readonly streetNumber?: InputMaybe<Scalars['String']['input']>
    readonly termsAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export interface UpdateNarrowcastingTabletInput {
    readonly name?: InputMaybe<Scalars['String']['input']>
}

export interface UpdateNarrowcastingTabletScheduleInput {
    readonly endDate: Scalars['Date']['input']
    readonly productIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly startDate: Scalars['Date']['input']
    readonly template: NarrowcastingDisplayTemplateEnum
}

export interface UpdatePassword {
    readonly old_password: Scalars['String']['input']
    readonly password: Scalars['String']['input']
    readonly password_confirmation: Scalars['String']['input']
}

export interface UpdatePasswordResponse {
    readonly message?: Maybe<Scalars['String']['output']>
    readonly status: Scalars['String']['output']
}

export interface UpdatePollInput {
    readonly clients: ReadonlyArray<QuestionClientInput>
    readonly endDate: Scalars['Date']['input']
    readonly id: Scalars['ID']['input']
    readonly startDate: Scalars['Date']['input']
    readonly translations: ReadonlyArray<QuestionTranslationInput>
    readonly type: QuestionTypeEnum
}

export interface UpdateProductCategoryInput {
    readonly id: Scalars['ID']['input']
    readonly name: Scalars['String']['input']
    readonly publicCategory: Scalars['ID']['input']
}

export interface UpdateProductInput {
    readonly additions?: InputMaybe<ReadonlyArray<CreateAdditionInput>>
    readonly allergenDeclarations?: InputMaybe<ReadonlyArray<ProductAllergenInput>>
    readonly category: Scalars['ID']['input']
    readonly dietaryClass?: InputMaybe<DietaryClassEnum>
    readonly id: Scalars['ID']['input']
    readonly image?: InputMaybe<DeletableFileInput>
    readonly marginPercentage: Scalars['Int']['input']
    readonly nutrients?: InputMaybe<ReadonlyArray<CreateNutrientForProductVersionInput>>
    readonly price: Scalars['Cent']['input']
    readonly tags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly translations: ReadonlyArray<ProductTranslationInput>
    readonly type: ProductTypeEnum
    readonly vatTariffPercentage?: InputMaybe<Scalars['Int']['input']>
    readonly versionTranslations: ReadonlyArray<ProductVersionTranslationInput>
}

export interface UpdatePublicCategoryInput {
    readonly id: Scalars['ID']['input']
    readonly translations: ReadonlyArray<PublicCategoryTranslationInput>
}

export interface UpdateRestaurantInput {
    readonly allowPickUpAtTheOffice: Scalars['Boolean']['input']
    readonly ambianceImage?: InputMaybe<DeletableFileInput>
    readonly dishBackgroundImage?: InputMaybe<DeletableFileInput>
    readonly id: Scalars['ID']['input']
    readonly locationId?: InputMaybe<Scalars['ID']['input']>
    readonly name: Scalars['String']['input']
    readonly orderDeadlineMarginMinutes: Scalars['Int']['input']
    readonly purchaseEnabled?: InputMaybe<Scalars['Boolean']['input']>
    readonly qrCodePickup: Scalars['Boolean']['input']
    readonly serviceReferenceId?: InputMaybe<Scalars['String']['input']>
    readonly translations: ReadonlyArray<RestaurantTranslationInput>
    readonly type: RestaurantTypeEnum
}

export interface UpdateStockResponse {
    readonly menuEntryOccurrenceID: Scalars['ID']['output']
    readonly mutationQuantity: Scalars['Int']['output']
    readonly mutationType: StockMutationTypeEnum
    readonly nextNumbers: StockNumbers
    readonly prevNumbers: StockNumbers
}

export interface UpdateUserAllergensInput {
    readonly allergens?: InputMaybe<ReadonlyArray<AllergensBelongsTo>>
}

export interface UpdateUserInput {
    readonly clientID: Scalars['ID']['input']
    readonly email?: InputMaybe<Scalars['String']['input']>
    readonly firstName?: InputMaybe<Scalars['String']['input']>
    readonly lastName?: InputMaybe<Scalars['String']['input']>
    readonly location?: InputMaybe<Scalars['ID']['input']>
    readonly preferredLanguage?: InputMaybe<Scalars['String']['input']>
    readonly restaurantId?: InputMaybe<Scalars['ID']['input']>
    readonly roles?: InputMaybe<ReadonlyArray<RoleInput>>
    readonly status?: InputMaybe<UserStatusEnum>
    readonly userId: Scalars['ID']['input']
    readonly userType?: InputMaybe<UserTypeEnum>
}

export interface User {
    readonly allergens: ReadonlyArray<Allergen>
    readonly avatar?: Maybe<Scalars['String']['output']>
    readonly cityName?: Maybe<Scalars['String']['output']>
    readonly client: Client
    readonly createdAt: Scalars['DateTime']['output']
    readonly deletedAt?: Maybe<Scalars['DateTime']['output']>
    readonly email: Scalars['String']['output']
    readonly firstName: Scalars['String']['output']
    readonly hasConfirmedTwoFactor: Scalars['Boolean']['output']
    readonly id: Scalars['ID']['output']
    readonly lastLogin?: Maybe<Scalars['DateTime']['output']>
    readonly lastName: Scalars['String']['output']
    readonly location?: Maybe<Location>
    readonly newsReadAt?: Maybe<Scalars['DateTime']['output']>
    /** @deprecated Office days will be removed soon. */
    readonly officeDays: ReadonlyArray<OfficeDay>
    readonly onboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>
    readonly postalCode?: Maybe<Scalars['String']['output']>
    readonly preferredLanguage: Scalars['String']['output']
    readonly privacyPolicyAcceptedAt?: Maybe<Scalars['DateTime']['output']>
    readonly requiresPrivacyPolicyAcceptance: Scalars['Boolean']['output']
    readonly requiresTermsAcceptance: Scalars['Boolean']['output']
    readonly restaurant?: Maybe<Restaurant>
    readonly roles: ReadonlyArray<Role>
    readonly status: UserStatusEnum
    readonly streetName?: Maybe<Scalars['String']['output']>
    readonly streetNumber?: Maybe<Scalars['String']['output']>
    readonly termsAcceptedAt?: Maybe<Scalars['DateTime']['output']>
    readonly updatedAt: Scalars['DateTime']['output']
    readonly userType: UserTypeEnum
}


export interface UserAvatarArgs {
    variant?: InputMaybe<UserAvatarVariant>
}

export interface UserAllergen {
    readonly allergen: Allergen
    readonly createdAt: Scalars['DateTime']['output']
    readonly id: Scalars['ID']['output']
    readonly updatedAt: Scalars['DateTime']['output']
    readonly user: User
}

/** Allowed resizes for the `variant` argument on the query `avatar`. */
export enum UserAvatarVariant {
    Original = 'ORIGINAL',
    Small = 'SMALL',
}

export interface UserFilter {
    readonly clients?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>
    readonly lastLogin?: InputMaybe<Scalars['Date']['input']>
    readonly query?: InputMaybe<Scalars['String']['input']>
    readonly roles?: InputMaybe<ReadonlyArray<RoleNameEnum>>
    readonly statuses?: InputMaybe<ReadonlyArray<UserStatusEnum>>
}

export interface UserStatus {
    readonly key: UserStatusEnum
    readonly value: Scalars['String']['output']
}

export enum UserStatusEnum {
    Active = 'ACTIVE',
    Blocked = 'BLOCKED',
    MustVerifyEmail = 'MUST_VERIFY_EMAIL',
}

export enum UserTypeEnum {
    Backoffice = 'BACKOFFICE',
    Customer = 'CUSTOMER',
    Kitchen = 'KITCHEN',
    Pos = 'POS',
}

export interface UsersFilterInput {
    readonly filters?: InputMaybe<UserFilter>
    readonly first: Scalars['Int']['input']
    readonly page?: InputMaybe<Scalars['Int']['input']>
}

export interface UsersPaginator {
    readonly data: ReadonlyArray<User>
    readonly paginatorInfo: PaginatorInfo
}

export interface VerifyEmailInput {
    readonly token: Scalars['String']['input']
}

export interface Voucher {
    readonly deactivatedAt?: Maybe<Scalars['String']['output']>
    readonly email: Scalars['String']['output']
    readonly endDate: Scalars['String']['output']
    readonly id: Scalars['Int']['output']
    readonly provider: IntegrationProviderEnum
    readonly startDate: Scalars['String']['output']
    /** @deprecated This has the same value as id. Use id instead. */
    readonly sysCode: Scalars['Int']['output']
    readonly voucherCode: Scalars['String']['output']
    readonly voucherOpenValue: Scalars['Int']['output']
    readonly voucherUsedValue: Scalars['Int']['output']
    readonly voucherValue: Scalars['Int']['output']
}

export enum VoucherEventType {
    /**
   * Indicates a voucher's **gain of value** as a consequence of **external** events.
   *
   * ---
   *
   * We cannot know for sure why this happened. Logs like these should be written any time we
   * fetch an external voucher record whose value information doesn't line up with what we
   * calculate from existing internal information, so as to correct our expectations of the
   * voucher state and come to consensus with the owning external system.
   */
    ExternalAppreciation = 'EXTERNAL_APPRECIATION',
    /**
   * Indicates a voucher's **loss of value** as a consequence of **external** events.
   *
   * ---
   *
   * We cannot know for sure why this happened. Logs like these should be written any time we
   * fetch an external voucher record whose value information doesn't line up with what we
   * calculate from existing internal information, so as to correct our expectations of the
   * voucher state and come to consensus with the owning external system.
   */
    ExternalDepreciation = 'EXTERNAL_DEPRECIATION',
    /** Indicates a voucher's **gain of value** as a consequence of internal events (refunds). */
    InternalAppreciation = 'INTERNAL_APPRECIATION',
    /** Indicates a voucher's **loss of value** as a consequence of internal events (payments). */
    InternalDepreciation = 'INTERNAL_DEPRECIATION',
}

export interface VoucherLog {
    readonly eventType: VoucherEventType
    readonly occurredAt: Scalars['DateTime']['output']
    readonly voucherValueAfter: Scalars['Cent']['output']
    readonly voucherValueBefore: Scalars['Cent']['output']
}

export interface VoucherUsageExportInput {
    readonly clientId?: InputMaybe<Scalars['ID']['input']>
    readonly endDate: Scalars['Date']['input']
    readonly startDate: Scalars['Date']['input']
}

export interface VoucherUsageInput {
    readonly code: Scalars['String']['input']
    readonly provider: IntegrationProviderEnum
}

export interface WalletBalance {
    readonly balanceInCents: Scalars['ID']['output']
}

/** Enumeration of all days of the week. */
export enum WeekDayEnum {
    Friday = 'FRIDAY',
    Monday = 'MONDAY',
    Saturday = 'SATURDAY',
    Sunday = 'SUNDAY',
    Thursday = 'THURSDAY',
    Tuesday = 'TUESDAY',
    Wednesday = 'WEDNESDAY',
}

export interface WeeklyOpeningHours {
    readonly FRIDAY?: Maybe<DailyOpeningHours>
    readonly MONDAY?: Maybe<DailyOpeningHours>
    readonly SATURDAY?: Maybe<DailyOpeningHours>
    readonly SUNDAY?: Maybe<DailyOpeningHours>
    readonly THURSDAY?: Maybe<DailyOpeningHours>
    readonly TUESDAY?: Maybe<DailyOpeningHours>
    readonly WEDNESDAY?: Maybe<DailyOpeningHours>
}

export interface TimeslotsInput {
    readonly date: Scalars['Date']['input']
    readonly restaurant: RestaurantBelongsTo
}

export type AdditionFragment = { readonly id: string; readonly name: string; readonly price: number }

export type AllergenFragment = { readonly id: string; readonly name: string; readonly icon?: string | null }

export type ClientThemeFragment = { readonly __typename: 'ClientTheme'; readonly colorError: string; readonly colorErrorContrast: string; readonly colorPrimary: string; readonly colorPrimaryContrast: string; readonly colorSecondary: string; readonly colorSecondaryContrast: string; readonly colorSuccess: string; readonly colorSuccessContrast: string; readonly colorTertiary: string; readonly colorTertiaryContrast: string; readonly colorTextDark: string; readonly colorTextLight: string; readonly colorWarning: string; readonly colorWarningContrast: string }

export type ClientFragment = { readonly __typename: 'Client'; readonly id: string; readonly name: string; readonly logo: string; readonly registrationShortcode: string; readonly emailQuestionsTo: string; readonly themes: { readonly web: ClientThemeFragment }; readonly domains: ReadonlyArray<{ readonly __typename: 'Domain'; readonly id: string; readonly name: string }> }

export type DishBackgroundImageFragment = { readonly ORIGINAL: string; readonly SQUARE_150: string; readonly SQUARE_300: string; readonly SQUARE_600: string }

export type LocationFragment = { readonly id: string; readonly name: string; readonly streetName: string; readonly streetNumber: string; readonly postalCode: string; readonly cityName: string; readonly costCenter?: string | null; readonly shortcode?: string | null; readonly restaurants: ReadonlyArray<RestaurantFragment> }

export type MeFragment = { readonly __typename: 'User'; readonly id: string; readonly createdAt: string; readonly updatedAt: string; readonly client: { readonly id: string; readonly registrationShortcode: string }; readonly location?: { readonly id: string; readonly shortcode?: string | null } | null }

export type NewsItemFragment = { readonly id: string; readonly content?: string | null; readonly title?: string | null; readonly intro?: string | null; readonly publishedAt?: string | null; readonly createdAt: string; readonly highlightedImage?: { readonly media: string } | null }

export type NutrientFragment = { readonly __typename: 'Nutrient'; readonly perHundredGram?: number | null; readonly NutrientType?: { readonly __typename: 'NutrientType'; readonly id: string; readonly name: string; readonly unit: NutrientTypeUnitEnum } | null }

export type WeeklyOpeningHoursFragment = { readonly MONDAY?: DailyOpeningHoursFragment | null; readonly TUESDAY?: DailyOpeningHoursFragment | null; readonly WEDNESDAY?: DailyOpeningHoursFragment | null; readonly THURSDAY?: DailyOpeningHoursFragment | null; readonly FRIDAY?: DailyOpeningHoursFragment | null; readonly SATURDAY?: DailyOpeningHoursFragment | null; readonly SUNDAY?: DailyOpeningHoursFragment | null }

export type DailyOpeningHoursFragment = { readonly weekday: WeekDayEnum; readonly openingTime: string; readonly closingTime: string }

export type PaginatorFragment = { readonly count: number; readonly currentPage: number; readonly firstItem?: number | null; readonly hasMorePages: boolean; readonly lastItem?: number | null; readonly lastPage: number; readonly perPage: number; readonly total: number }

export type ProductVersionFragment = { readonly id: string; readonly description?: string | null; readonly additions: ReadonlyArray<AdditionFragment>; readonly allergens: ReadonlyArray<AllergenFragment>; readonly nutrients: ReadonlyArray<NutrientFragment>; readonly image?: { readonly variants: { readonly SQUARE_150: string; readonly SQUARE_300: string; readonly SQUARE_600: string; readonly ORIGINAL: string } } | null }

export type ProductFragment = { readonly id: string; readonly name: string; readonly tagline?: string | null; readonly type: ProductTypeEnum; readonly tags: ReadonlyArray<TagFragment>; readonly category: { readonly name: string }; readonly currentVersion: ProductVersionFragment }

export type RestaurantOrderStrategyFragment = { readonly clientID: string; readonly restaurantID: string; readonly value: OrderStrategyEnum; readonly note?: string | null }

export type RestaurantFragment = { readonly id: string; readonly name: string; readonly type: RestaurantTypeEnum; readonly isQrCodePickup: boolean; readonly orderDeadlineMarginMinutes: number; readonly location?: { readonly id: string; readonly shortcode?: string | null } | null; readonly ambianceImage: { readonly original: string; readonly rectangle_615: string }; readonly orderStrategies: ReadonlyArray<RestaurantOrderStrategyFragment>; readonly weeklyOpeningHours: WeeklyOpeningHoursFragment; readonly dishBackgroundImage?: DishBackgroundImageFragment | null }

export type TagFragment = { readonly __typename: 'Tag'; readonly id: string; readonly name: string }

export type ApiStockNumbersFragment = { readonly amountTotalInitial?: number | null; readonly amountTotalCorrection: number; readonly amountTotal?: number | null; readonly amountClaimed: number; readonly amountIssued: number; readonly amountReserved: number; readonly amountAvailable?: number | null; readonly amountIssuable?: number | null; readonly isConstrained: boolean; readonly isExhausted: boolean; readonly isCorrected: boolean }

export type ApiVersionQueryVariables = Exact<{ [key: string]: never }>


export type ApiVersionQuery = { readonly apiVersion: { readonly version: string } }

export type ClientQueryVariables = Exact<{
    id: Scalars['ID']['input']
}>


export type ClientQuery = { readonly client: ClientFragment }

export type ClientByShortcodeQueryVariables = Exact<{
    shortcode: Scalars['String']['input']
}>


export type ClientByShortcodeQuery = { readonly clients: { readonly data: ReadonlyArray<ClientFragment> } }

export type DailyMenuItemImagesFragment = { readonly original: string; readonly square150: string; readonly square300: string; readonly square600: string }

export type DailyMenuItemSourceIDsFragment = { readonly menuEntry: string; readonly menuEntryOccurrence: string; readonly product: string; readonly productVersion: string }

export type DailyMenuItemFragment = { readonly name: string; readonly tagline?: string | null; readonly description?: string | null; readonly price: number; readonly tags: ReadonlyArray<{ readonly name: string }>; readonly sources: DailyMenuItemSourceIDsFragment; readonly context: { readonly restaurantID: string }; readonly category: { readonly id: string; readonly name: string }; readonly allergens: ReadonlyArray<AllergenFragment>; readonly nutrients: ReadonlyArray<NutrientFragment>; readonly additions: ReadonlyArray<AdditionFragment>; readonly images?: DailyMenuItemImagesFragment | null; readonly stock: ApiStockNumbersFragment }

export type DailyMenuItemQueryVariables = Exact<{
    clientID: Scalars['ID']['input']
    occurrenceID: Scalars['ID']['input']
}>


export type DailyMenuItemQuery = { readonly dailyMenuItem: DailyMenuItemFragment }

export type DailyMenuQueryVariables = Exact<{
    clientID: Scalars['ID']['input']
    date: Scalars['Date']['input']
    filters?: InputMaybe<DailyMenuFilters>
}>


export type DailyMenuQuery = { readonly dailyMenu?: { readonly date: string; readonly restaurants: ReadonlyArray<{ readonly items: ReadonlyArray<DailyMenuItemFragment> }> } | null }

export type LatestNewsItemQueryVariables = Exact<{
    clientID: Scalars['ID']['input']
}>


export type LatestNewsItemQuery = { readonly newsItems: { readonly data: ReadonlyArray<NewsItemFragment> } }

export type LocationQueryVariables = Exact<{
    shortcode: Scalars['String']['input']
}>


export type LocationQuery = { readonly locationByShortcode?: LocationFragment | null }

export type LocationsQueryVariables = Exact<{
    filter?: InputMaybe<LocationsFilterInput>
}>


export type LocationsQuery = { readonly locations: { readonly data: ReadonlyArray<LocationFragment> } }

export type NewsItemQueryVariables = Exact<{
    id: Scalars['ID']['input']
}>


export type NewsItemQuery = { readonly newsItem: NewsItemFragment }

export type RestaurantQueryVariables = Exact<{
    id: Scalars['ID']['input']
}>


export type RestaurantQuery = { readonly restaurant: RestaurantFragment }

export type RestaurantsQueryVariables = Exact<{
    input: RestaurantsInput
}>


export type RestaurantsQuery = { readonly restaurants: { readonly data: ReadonlyArray<RestaurantFragment>; readonly paginatorInfo: PaginatorFragment } }

export const ClientThemeFragmentDoc = gql`
    fragment ClientTheme on ClientTheme {
  __typename
  colorError
  colorErrorContrast
  colorPrimary
  colorPrimaryContrast
  colorSecondary
  colorSecondaryContrast
  colorSuccess
  colorSuccessContrast
  colorTertiary
  colorTertiaryContrast
  colorTextDark
  colorTextLight
  colorWarning
  colorWarningContrast
}
    `
export const ClientFragmentDoc = gql`
    fragment Client on Client {
  __typename
  id
  name
  logo
  registrationShortcode
  emailQuestionsTo
  themes {
    web {
      ...ClientTheme
    }
  }
  domains {
    id
    name
    __typename
  }
}
    ${ClientThemeFragmentDoc}`
export const RestaurantOrderStrategyFragmentDoc = gql`
    fragment RestaurantOrderStrategy on RestaurantOrderStrategy {
  clientID
  restaurantID
  value
  note
}
    `
export const DailyOpeningHoursFragmentDoc = gql`
    fragment DailyOpeningHours on DailyOpeningHours {
  weekday
  openingTime
  closingTime
}
    `
export const WeeklyOpeningHoursFragmentDoc = gql`
    fragment WeeklyOpeningHours on WeeklyOpeningHours {
  MONDAY {
    ...DailyOpeningHours
  }
  TUESDAY {
    ...DailyOpeningHours
  }
  WEDNESDAY {
    ...DailyOpeningHours
  }
  THURSDAY {
    ...DailyOpeningHours
  }
  FRIDAY {
    ...DailyOpeningHours
  }
  SATURDAY {
    ...DailyOpeningHours
  }
  SUNDAY {
    ...DailyOpeningHours
  }
}
    ${DailyOpeningHoursFragmentDoc}`
export const DishBackgroundImageFragmentDoc = gql`
    fragment DishBackgroundImage on DishBackgroundImages {
  ORIGINAL
  SQUARE_150
  SQUARE_300
  SQUARE_600
}
    `
export const RestaurantFragmentDoc = gql`
    fragment Restaurant on Restaurant {
  id
  name
  type
  isQrCodePickup
  orderDeadlineMarginMinutes
  location {
    id
    shortcode
  }
  ambianceImage {
    original
    rectangle_615
  }
  orderStrategies {
    ...RestaurantOrderStrategy
  }
  weeklyOpeningHours {
    ...WeeklyOpeningHours
  }
  dishBackgroundImage {
    ...DishBackgroundImage
  }
}
    ${RestaurantOrderStrategyFragmentDoc}
${WeeklyOpeningHoursFragmentDoc}
${DishBackgroundImageFragmentDoc}`
export const LocationFragmentDoc = gql`
    fragment Location on Location {
  id
  name
  streetName
  streetNumber
  postalCode
  cityName
  costCenter
  shortcode
  restaurants {
    ...Restaurant
  }
}
    ${RestaurantFragmentDoc}`
export const MeFragmentDoc = gql`
    fragment Me on User {
  __typename
  id
  createdAt
  updatedAt
  client {
    id
    registrationShortcode
  }
  location {
    id
    shortcode
  }
}
    `
export const NewsItemFragmentDoc = gql`
    fragment NewsItem on NewsItem {
  id
  content
  title
  intro
  content
  highlightedImage {
    media
  }
  publishedAt
  createdAt
}
    `
export const PaginatorFragmentDoc = gql`
    fragment Paginator on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  id
  name
  __typename
}
    `
export const AdditionFragmentDoc = gql`
    fragment Addition on Addition {
  id
  name
  price
}
    `
export const AllergenFragmentDoc = gql`
    fragment Allergen on Allergen {
  id
  name
  icon
}
    `
export const NutrientFragmentDoc = gql`
    fragment Nutrient on Nutrient {
  __typename
  NutrientType {
    __typename
    id
    name
    unit
  }
  perHundredGram
}
    `
export const ProductVersionFragmentDoc = gql`
    fragment ProductVersion on ProductVersion {
  id
  additions {
    ...Addition
  }
  allergens {
    ...Allergen
  }
  nutrients {
    ...Nutrient
  }
  description
  image {
    variants {
      SQUARE_150
      SQUARE_300
      SQUARE_600
      ORIGINAL
    }
  }
}
    ${AdditionFragmentDoc}
${AllergenFragmentDoc}
${NutrientFragmentDoc}`
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  name
  tagline
  tags {
    ...Tag
  }
  type
  category {
    name
  }
  currentVersion {
    ...ProductVersion
  }
}
    ${TagFragmentDoc}
${ProductVersionFragmentDoc}`
export const DailyMenuItemSourceIDsFragmentDoc = gql`
    fragment DailyMenuItemSourceIDs on DailyMenuItemSourceIDs {
  menuEntry
  menuEntryOccurrence
  product
  productVersion
}
    `
export const DailyMenuItemImagesFragmentDoc = gql`
    fragment DailyMenuItemImages on DailyMenuItemImages {
  original
  square150
  square300
  square600
}
    `
export const ApiStockNumbersFragmentDoc = gql`
    fragment ApiStockNumbers on StockNumbers {
  amountTotalInitial
  amountTotalCorrection
  amountTotal
  amountClaimed
  amountIssued
  amountReserved
  amountAvailable
  amountIssuable
  isConstrained
  isExhausted
  isCorrected
}
    `
export const DailyMenuItemFragmentDoc = gql`
    fragment DailyMenuItem on DailyMenuItem {
  name
  tagline
  description
  price
  tags {
    name
  }
  sources {
    ...DailyMenuItemSourceIDs
  }
  context {
    restaurantID
  }
  category: publicCategory {
    id
    name
  }
  allergens {
    ...Allergen
  }
  nutrients {
    ...Nutrient
  }
  additions {
    ...Addition
  }
  images {
    ...DailyMenuItemImages
  }
  stock {
    ...ApiStockNumbers
  }
}
    ${DailyMenuItemSourceIDsFragmentDoc}
${AllergenFragmentDoc}
${NutrientFragmentDoc}
${AdditionFragmentDoc}
${DailyMenuItemImagesFragmentDoc}
${ApiStockNumbersFragmentDoc}`
export const ApiVersionDocument = gql`
    query apiVersion {
  apiVersion {
    version
  }
}
    `

@Injectable({
    providedIn: 'root',
})
export class ApiVersionQueryService extends Apollo.Query<ApiVersionQuery, ApiVersionQueryVariables> {
    override document = ApiVersionDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const ClientDocument = gql`
    query client($id: ID!) {
  client(id: $id) {
    ...Client
  }
}
    ${ClientFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class ClientQueryService extends Apollo.Query<ClientQuery, ClientQueryVariables> {
    override document = ClientDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const ClientByShortcodeDocument = gql`
    query clientByShortcode($shortcode: String!) {
  clients(input: {filters: {query: $shortcode}, first: 1, page: 1}) {
    data {
      ...Client
    }
  }
}
    ${ClientFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class ClientByShortcodeQueryService extends Apollo.Query<ClientByShortcodeQuery, ClientByShortcodeQueryVariables> {
    override document = ClientByShortcodeDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const DailyMenuItemDocument = gql`
    query dailyMenuItem($clientID: ID!, $occurrenceID: ID!) {
  dailyMenuItem(clientID: $clientID, menuEntryOccurrenceID: $occurrenceID) {
    ...DailyMenuItem
  }
}
    ${DailyMenuItemFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class DailyMenuItemQueryService extends Apollo.Query<DailyMenuItemQuery, DailyMenuItemQueryVariables> {
    override document = DailyMenuItemDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const DailyMenuDocument = gql`
    query dailyMenu($clientID: ID!, $date: Date!, $filters: DailyMenuFilters) {
  dailyMenu(clientID: $clientID, date: $date, filters: $filters) {
    date
    restaurants {
      items {
        ...DailyMenuItem
      }
    }
  }
}
    ${DailyMenuItemFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class DailyMenuQueryService extends Apollo.Query<DailyMenuQuery, DailyMenuQueryVariables> {
    override document = DailyMenuDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const LatestNewsItemDocument = gql`
    query latestNewsItem($clientID: ID!) {
  newsItems(
    input: {clients: [$clientID], sorting: {key: "published_at", direction: DESCENDING}, pagination: {page: 1, first: 1}}
  ) {
    data {
      ...NewsItem
    }
  }
}
    ${NewsItemFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class LatestNewsItemQueryService extends Apollo.Query<LatestNewsItemQuery, LatestNewsItemQueryVariables> {
    override document = LatestNewsItemDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const LocationDocument = gql`
    query location($shortcode: String!) {
  locationByShortcode(shortcode: $shortcode) {
    ...Location
  }
}
    ${LocationFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class LocationQueryService extends Apollo.Query<LocationQuery, LocationQueryVariables> {
    override document = LocationDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const LocationsDocument = gql`
    query locations($filter: LocationsFilterInput) {
  locations(input: {filters: $filter, first: 100, page: 1}) {
    data {
      ...Location
    }
  }
}
    ${LocationFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class LocationsQueryService extends Apollo.Query<LocationsQuery, LocationsQueryVariables> {
    override document = LocationsDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const NewsItemDocument = gql`
    query newsItem($id: ID!) {
  newsItem(id: $id) {
    ...NewsItem
  }
}
    ${NewsItemFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class NewsItemQueryService extends Apollo.Query<NewsItemQuery, NewsItemQueryVariables> {
    override document = NewsItemDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const RestaurantDocument = gql`
    query restaurant($id: ID!) {
  restaurant(id: $id) {
    ...Restaurant
  }
}
    ${RestaurantFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class RestaurantQueryService extends Apollo.Query<RestaurantQuery, RestaurantQueryVariables> {
    override document = RestaurantDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const RestaurantsDocument = gql`
    query restaurants($input: RestaurantsInput!) {
  restaurants(input: $input) {
    data {
      ...Restaurant
    }
    paginatorInfo {
      ...Paginator
    }
  }
}
    ${RestaurantFragmentDoc}
${PaginatorFragmentDoc}`

@Injectable({
    providedIn: 'root',
})
export class RestaurantsQueryService extends Apollo.Query<RestaurantsQuery, RestaurantsQueryVariables> {
    override document = RestaurantsDocument
    
    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}